export default {
  "appName": "Phoenix",
  "welcome": {
    "modalAria": "Welcome to Phoenix",
    "skip": "Skip",
    "next": "Next",
    "getStarted": "Get started",
    "slides": {
      "intro":    { "title": "Welcome to Phoenix",     "body": "A single home for your daily check-ins, partner games, news, and the long-tail modules — everything you'd otherwise juggle across a dozen apps." },
      "couples":  { "title": "Built for the two of you", "body": "Daily questions, Wordle, and a Newlywed-style quiz keep you and your partner in sync — see each other's answers as they happen." },
      "tracking": { "title": "Track what matters",     "body": "Weight, meals, water, workouts — log in seconds, see the trend in the dashboard. No charts you have to babysit." },
      "feed":     { "title": "News & social in one",   "body": "Reddit, Bluesky, Mastodon, YouTube, RSS — your sources in one feed, auto-translated when you need it." },
      "yours":    { "title": "Make it yours",          "body": "Theme, colour, font, voices, reminders — Settings has the dials. The defaults are good, your taste is better." }
    }
  },
  "tour": {
    "stepCounter": "Step {{current}} of {{total}}",
    "skip": "Skip tour",
    "skipAria": "Skip the tour",
    "back": "Back",
    "next": "Next",
    "finish": "Done",
    "steps": {
      "greeting":  { "title": "Your daily home", "body": "Every cold launch lands here — the Today dashboard is your starting point. Date and joint-streak badge live up top." },
      "checkins":  { "title": "Today's check-ins", "body": "Tap any pill to log it — they flip to green once you've done it for the day." },
      "couples":   { "title": "You & your partner", "body": "Daily question, Wordle, and Quiz status — all three update live based on what you and your partner have done today." },
      "headline":  { "title": "What's worth reading", "body": "Top story from your followed sources, auto-translated when needed. Tap to open the full article." },
      "modules":   { "title": "The rest of the app", "body": "Reports, finance, phases, health — the modules you don't open daily live here so they're never more than two taps away." },
      "bottomBar": { "title": "Your main tabs", "body": "Today, Meals, Workouts, Social, Weight, Profile — your six daily destinations. Tap the active one again to scroll back to top." },
      "profile":   { "title": "Your profile", "body": "Tap your photo to edit your profile or open the side drawer for Settings, Reports, and more." }
    }
  },
  "features": {
    "gotIt": "Got it",
    "couplesQuiz":     { "title": "Couples Quiz",        "body": "Newlywed-style 5-question rounds — see how well you know each other." },
    "dailyQuestion":   { "title": "Daily Question",      "body": "One question a day for both of you, with the reveal shown side-by-side." },
    "wordle":          { "title": "Daily Wordle",        "body": "Five-letter word, six tries — streak counts the days you both played." },
    "profileEdit":     { "title": "Profile",             "body": "Edit your name, birthday, photo and identity fields in one place." },
    "reports":         { "title": "Reports",             "body": "Period HTML reports covering weight, meals, workouts, and progress." },
    "financeDues":     { "title": "Dues Sheet",          "body": "Installments and recurring bills — never miss a due date." },
    "phases":          { "title": "Life Phases",         "body": "Map the chapters of your life with their own pages." },
    "settings":        { "title": "Settings",            "body": "Theme, colour, font, voices, notifications — all yours to tune." },
    "tourReplay":      { "title": "Tour",                "body": "Replay the spotlight tour any time from Settings." },
    "todayDashboard":  { "title": "Today",               "body": "Your new home — every section pulled into one glance." },
    "tipCard":         { "title": "Feature tips",        "body": "A rotating tip card surfaces features you might've missed." }
  },
  "debug": {
    "open": "Open debug log",
    "close": "Close",
    "title": "Debug log",
    "count": "{{count}} entries · {{errors}} errors",
    "filter": {
      "all": "All",
      "warn": "Warn+",
      "error": "Errors"
    },
    "copy": "Copy all",
    "copied": "Copied",
    "clear": "Clear",
    "empty": "No log entries yet. Use the app — anything you log will appear here."
  },
  "tips": {
    "label": "Tip"
  },
  "notifications": {
    "promptTitle": "Stay in the loop",
    "promptBody": "Enable notifications and we'll send a daily check-in at 9 AM plus partner pings when your half of a quiz or question is ready.",
    "enable": "Enable",
    "enabling": "Enabling…",
    "notNow": "Not now",
    "enableFailed": "Couldn't enable — check your connection and try again.",
    "bannerTitle": "Notifications are off",
    "bannerBody": "Tap to enable from Settings",
    "bannerBodyBlocked": "Blocked by your browser — unblock from site settings then enable here"
  },
  "english": {
    "title": "English",
    "subtitle": "Learn smarter — review, capture, and track your course",
    "welcomeHint": "Save words from any article, review them daily, and log your course progress.",
    "dashboard": {
      "reviewTitle": "Review",
      "reviewSubtitle": "Practice today's due words",
      "reviewDue_one": "{{count}} word due today",
      "reviewDue_other": "{{count}} words due today",
      "vocabTitle": "Vocabulary",
      "vocabSubtitle": "Words you've saved from reading",
      "courseTitle": "Course",
      "courseSubtitle": "Track your Udemy / online course",
      "courseSubtitleActive": "{{title}} — {{done}}/{{total}} lectures",
      "tutorTitle": "Tutor",
      "tutorSubtitle": "Chat with an ESL tutor — corrections + practice",
      "speakTitle": "Speak",
      "speakSubtitle": "Practice pronunciation out loud"
    },
    "speak": {
      "title": "Speak",
      "subtitle_one": "{{count}} word to practice",
      "subtitle_other": "{{count}} words to practice",
      "empty": "No words to practice yet",
      "emptyHint": "Save a few words first, then come back to drill your pronunciation.",
      "unsupported": "Speech recognition isn't available on this device",
      "unsupportedHint": "This drill uses the browser's speech API. Try opening the app in Safari or Chrome on a recent device.",
      "targetLabel": "Say this word",
      "listen": "Hear it",
      "record": "Tap to record",
      "stop": "Stop",
      "tapToRecord": "Tap the mic and say the word",
      "listening": "Listening…",
      "heard": "What I heard",
      "tryAgain": "Try again",
      "next": "Next",
      "skip": "Skip",
      "score": {
        "great": "Great pronunciation!",
        "ok": "Close — try once more",
        "retry": "Not quite — try again"
      },
      "errors": {
        "not-allowed": "Microphone permission denied. Allow it in Safari settings, then retry.",
        "no-speech": "Didn't catch anything — try again, a bit louder.",
        "audio-capture": "Couldn't access the microphone. Check your device permissions.",
        "network": "Network error during recognition.",
        "service-not-allowed": "Speech recognition is blocked here. Try opening phoenixtrackers.com in Safari (not the installed app) for now.",
        "no-start": "The mic didn't start. Installed PWAs sometimes block speech — try Safari instead, or tell me and I'll wire up cloud transcription."
      }
    },
    "drill": {
      "cta": "Quiz me on this article",
      "ctaHint": "3-5 questions to check your reading.",
      "start": "Start",
      "loading": "Building your quiz…",
      "progress": "Q {{current}} of {{total}}",
      "nextQuestion": "Next",
      "finish": "Finish",
      "doneTitle": "Quiz done",
      "score": "{{correct}} / {{total}} correct",
      "fresh": "Fresh set",
      "retry": "Retry",
      "error": "Couldn't build the quiz from this article."
    },
    "tutor": {
      "title": "Tutor",
      "subtitle": "Talk it out — corrections, recasts, practice",
      "welcome": "Hey! I'm your English tutor. We can roleplay scenarios, check sentences you're unsure about, or just chat. Pick one to get started, or type anything.",
      "placeholder": "Write in English — I'll correct gently",
      "send": "Send",
      "reset": "Reset conversation",
      "thinking": "Tutor is thinking…",
      "suggestions": {
        "roleplay": "Role-play: ordering coffee in a café",
        "checkSentence": "Check this sentence: \"I have went to the gym yesterday\"",
        "practiceTense": "Let's practice past simple — give me 3 prompts",
        "casualChat": "Just casual chat about my day"
      }
    },
    "course": {
      "title": "Course",
      "subtitle_one": "{{count}} course tracked",
      "subtitle_other": "{{count}} courses tracked",
      "empty": "No course yet",
      "emptyHint": "Add the course you're taking (Udemy, Coursera, anything) and log lectures as you complete them.",
      "addTitle": "Add a course",
      "titleLabel": "Course title",
      "titlePlaceholder": "Complete English Course",
      "platformLabel": "Platform",
      "urlLabel": "URL (optional)",
      "instructorLabel": "Instructor (optional)",
      "instructorPlaceholder": "Name of the teacher",
      "totalLabel": "Total lectures (optional)",
      "save": "Save course",
      "cancel": "Cancel",
      "delete": "Delete",
      "confirmDelete": "Tap again to confirm",
      "openSource": "Open course",
      "progress": "{{done}}/{{total}} lectures",
      "showLectures_one": "Show {{count}} lecture",
      "showLectures_other": "Show {{count}} lectures",
      "hideLectures": "Hide lectures",
      "addLecture": "Lecture",
      "markComplete": "Mark complete",
      "markIncomplete": "Mark as in progress",
      "lectureAddTitle": "Log a lecture",
      "lectureTitleLabel": "Lecture title",
      "lectureTitlePlaceholder": "Conditional sentences — type 1",
      "lectureNumberLabel": "Lecture #",
      "durationLabel": "Duration (min)",
      "durationPlaceholder": "12",
      "sectionLabel": "Section (optional)",
      "sectionPlaceholder": "Section 3 — Tenses",
      "notesLabel": "Notes (optional)",
      "notesPlaceholder": "Anything to remember from this lecture…",
      "lectureSave": "Save lecture",
      "lectureEmpty": "No lectures logged yet. Tap \"Lecture\" to add one."
    },
    "review": {
      "title": "Review",
      "progress": "{{done}} done · {{remaining}} to go",
      "reveal": "Show answer",
      "speak": "Pronounce",
      "empty": "Nothing due today",
      "emptyHint": "Add a few words from any article, then come back here.",
      "doneTitle": "Nice work!",
      "doneBody_one": "You reviewed {{count}} word today.",
      "doneBody_other": "You reviewed {{count}} words today.",
      "backToDashboard": "Back to English",
      "rate": {
        "again": "Again",
        "hard": "Hard",
        "good": "Good",
        "easy": "Easy"
      }
    },
    "vocab": {
      "title": "Vocabulary",
      "subtitle": "{{count}} words saved",
      "addTitle": "Save a word",
      "wordLabel": "Word or phrase",
      "wordPlaceholder": "e.g. resilient",
      "contextLabel": "Sentence (optional)",
      "contextPlaceholder": "The sentence you saw it in",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "confirmDelete": "Tap again to confirm",
      "speak": "Pronounce",
      "empty": "No words saved yet",
      "emptyHint": "Tap a word in any article, or use the + button to add one manually.",
      "emptyFiltered": "Nothing matches the current filter.",
      "searchPlaceholder": "Search your words…",
      "saveFromArticle": "Save to English",
      "saveFromSelection": "Save",
      "speakSelection": "Speak",
      "translateSelection": "Translate",
      "translating": "Translating…",
      "closeTranslation": "Close translation",
      "state": {
        "all": "All",
        "new": "New",
        "learning": "Learning",
        "review": "Review",
        "suspended": "Suspended"
      },
      "source": {
        "news": "News",
        "social": "Social",
        "tech": "Tech",
        "course": "Course",
        "manual": "Manual"
      }
    }
  },
  "learning": {
    "title": "Learning",
    "subtitle": "{{count}} resources · {{done}} completed",
    "addResource": "Add resource",
    "allTopics": "All topics",
    "open": "Open",
    "empty": "Nothing here yet",
    "emptyHint": "Add the first article, video, or course you're learning from.",
    "saveFailed": "Couldn't save — try again",
    "markComplete": "Mark as completed",
    "markIncomplete": "Mark as in-progress",
    "suggestForTopic": "Suggest more for: {{topic}}",
    "suggestTitle": "Suggestions for {{topic}}",
    "suggestLoading": "Looking for great resources…",
    "suggestEmpty": "Couldn't find anything — try a different topic.",
    "fetchingMeta": "Fetching link info…",
    "added": "Added",
    "bootstrapping": "Pulling a starter set of resources for you…",
    "type": {
      "all": "All",
      "article": "Article",
      "video": "Video",
      "lesson": "Lesson",
      "course": "Course",
      "other": "Other"
    },
    "fields": {
      "url": "Link",
      "title": "Title",
      "topic": "Topic",
      "topicPlaceholder": "e.g. Swimming",
      "type": "Type",
      "notes": "Notes",
      "notesPlaceholder": "Why this resource matters to you (optional)"
    }
  },
  "articleChat": {
    "cta": "Ask AI about this article",
    "title": "Ask AI",
    "placeholder": "Ask anything about this article…"
  },
  "miniPlayer": {
    "popOut": "Keep playing while I browse",
    "expand": "Expand",
    "close": "Close mini player"
  },
  "assistant": {
    "tile": "Assistant",
    "title": "Phoenix Assistant",
    "subtitle": "Ask anything about your data",
    "placeholder": "Type a question…",
    "send": "Send",
    "thinking": "Thinking…",
    "error": "Something went wrong: {{error}}",
    "suggestionsHint": "Try one of these:",
    "clearChat": "Clear chat"
  },
  "insights": {
    "title": "This week's AI review",
    "emptyHint": "Your weekly review will appear here after the Sunday digest, or generate one now.",
    "generateNow": "Generate now",
    "status": {
      "no_activity": "Not enough tracked activity this week to review yet.",
      "llm_failed": "The AI provider failed — try again in a minute.",
      "empty_response": "The AI returned nothing — try again.",
      "write_failed": "Generated but couldn't save — try again."
    },
    "refresh": "Regenerate insights",
    "expand": "Read more",
    "collapse": "Show less",
    "translate": "Translate",
    "showOriginal": "Show original"
  },
  "common": {
    "confirm": "Confirm",
    "cancel": "Cancel",
    "close": "Close",
    "save": "Save",
    "saving": "Saving…",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "confirmDelete": "Delete this item?",
    "actions": "Actions",
    "clear": "Clear",
    "show": "Show",
    "hide": "Hide"
  },
  "journey": {
    "title": "Journey",
    "subtitle": "Private reflection log",
    "tableMissing": "Journey isn't ready yet. Check back in a minute.",
    "stats": {
      "title": "Last 7 / 30 days",
      "resistanceRate7": "Resistance · 7d",
      "resistanceRate30": "Resistance · 30d",
      "daysSinceLapse": "Days since last lapse",
      "noLapseYet": "No lapses logged yet",
      "checkins": "Check-ins",
      "topTriggers": "Top triggers (30d)"
    },
    "voice": {
      "title": "Voice journal",
      "placeholder": "Speak or type what's on your mind…",
      "mic": "Record",
      "save": "Save entry",
      "saved": "Saved — extracted:",
      "failed": "Couldn't save — try again."
    },
    "checkin": {
      "title": "Today's check-in",
      "mood": "Mood",
      "energy": "Energy",
      "urgesToday": "Urge(s) today",
      "noUrges": "No urges today",
      "notesPlaceholder": "How was the day? (optional)"
    },
    "urge": {
      "title": "Urge log",
      "add": "Log an urge",
      "empty": "No urges logged. Each urge — resisted or not — is data to learn from.",
      "intensity": "Intensity (1 low – 5 high)",
      "response": "What happened?",
      "resisted": "Resisted",
      "lapsed": "Lapsed",
      "triggerPlaceholder": "What triggered it? (boredom, stress, scrolling, etc.)",
      "notesPlaceholder": "Anything else worth noting? (optional)",
      "confirmDelete": "Delete this entry?"
    }
  },
  "ai": {
    "thinking": "Thinking…",
    "refresh": "Refresh",
    "retry": "Retry",
    "errorTitle": "Couldn't reach the AI service",
    "workoutCoach": {
      "title": "Workout coach",
      "description": "Get an AI-powered review of your last 30 days of training, on demand. Your privacy is protected — it never reads your finance or health data.",
      "cta": "Get coach's note"
    },
    "mealCoach": {
      "title": "Meal coach",
      "description": "Get an AI-powered review of your last 14 days of meals + macros, on demand. Your privacy is protected — it never reads your finance or health data.",
      "cta": "Get coach's note"
    },
    "history": {
      "title": "Past notes ({{count}})",
      "confirmDelete": "Delete this saved note?",
      "tableMissing": "Saving past notes isn't ready yet."
    }
  },
  "newsSubs": {
    "title": "My subscriptions",
    "sources": "Sources",
    "sourcesEmpty": "No source subscriptions yet. Open any source's page and pick a notification mode.",
    "topics": "Topics",
    "topicsEmpty": "No topic subscriptions yet. Add a keyword below.",
    "addTopicHint": "Subscribe to a keyword or tag. Matches against article titles, tags, and categories.",
    "topicPlaceholder": "e.g. immigration, Egypt visa, MacBook…",
    "addTopic": "Add"
  },
  "newsSource": {
    "notFound": "Source not found.",
    "articles": "articles",
    "notifyMe": "Notify me",
    "modeOff": "Off",
    "modeDaily": "Daily digest",
    "modeInstant": "Instant",
    "modeOffHint": "You won't get any push notifications from this source.",
    "modeDailyHint": "One batched push at 12 PM with everything new from your subscriptions.",
    "modeInstantHint": "A push for each new article from this source (up to 8 per check).",
    "latestArticles": "Latest articles",
    "empty": "No articles for this source yet."
  },
  "social": {
    "title": "Social"
  },
  "tech": {
    "title": "Tech"
  },
  "news": {
    "title": "News",
    "openSourcePage": "View {{name}} page (subscribe + notifications)",
    "empty": "No articles cached yet.",
    "emptyHint": "Trigger fetch-news from the Edge Functions dashboard or wait for the next cron tick.",
    "savedEmpty": "No saved articles yet.",
    "savedEmptyHint": "Tap the bookmark on any article you want to come back to.",
    "savedShowOnly": "Show saved only",
    "savedShowAll": "Show all articles",
    "readEmpty": "No read articles yet.",
    "readEmptyHint": "Articles you open — or mark with the eye icon — land here.",
    "markAsRead": "Mark as read",
    "markAsUnread": "Mark as unread",
    "read": "Read",
    "unread": "Unread",
    "reddit": {
      "sortNew": "New",
      "sortTop": "Top",
      "topComment": "Top comment",
      "crosspostFrom": "Crosspost from {{sub}}",
      "silent": "MUTED",
      "commentsTitle": "Comments",
      "commentsLoading": "Loading comments…",
      "commentsEmpty": "No comments yet.",
      "commentsError": "Could not load comments: {{error}}",
      "translateAll": "Translate",
      "showOriginal": "Show original",
      "translateError": "Translation failed: {{error}}",
      "refreshComments": "Refresh comments",
      "cachedHint": "Fetched {{time}}",
      "searchOnReddit": "Search Reddit",
      "searching": "Searching Reddit…",
      "externalResults": "Results from Reddit",
      "externalBadge": "From Reddit",
      "clearExternal": "Hide Reddit results",
      "searchError": "Reddit search failed: {{error}}"
    },
    "loadMore": "Load more",
    "allLoaded": "You're all the way down.",
    "view": {
      "all": "All",
      "read": "Read",
      "saved": "Saved"
    },
    "filters": {
      "toggle": "Toggle filters",
      "title": "Filters"
    },
    "fetchNow": {
      "label": "Fetch latest now",
      "success": "{{count}} new articles fetched",
      "successEmpty": "Up to date — no new articles",
      "error": "Couldn't fetch — try again in a minute"
    },
    "search": {
      "label": "Search",
      "placeholder": "Search titles and snippets…"
    },
    "digest": {
      "title": "Today's digest",
      "weeklyTitle": "This week's digest",
      "articlesShort": "articles",
      "expand": "Read more",
      "collapse": "Show less",
      "refresh": "Regenerate digest",
      "translate": "Translate",
      "showOriginal": "Show original"
    },
    "trending": {
      "title": "Trending now"
    },
    "lastFetched": "Last updated {{time}} ago",
    "tableMissing": "News isn't ready yet. Check back in a minute.",
    "youtube": {
      "title": "YouTube",
      "allChannels": "All channels",
      "searchPlaceholder": "Search videos…",
      "clearSearch": "Clear search",
      "searchEmpty": "No videos match \"{{query}}\"",
      "searchEmptyHint": "Try a different keyword or clear the search.",
      "empty": "No videos yet",
      "emptyHint": "Subscribed channels' latest uploads will appear here.",
      "tabAll": "All",
      "tabVideos": "Videos",
      "tabShorts": "Shorts",
      "tabSaved": "Saved",
      "tabHistory": "History",
      "historyEmpty": "No watch history yet",
      "historyEmptyHint": "Videos you watch from here will show up so you can find them again later.",
      "historyCount": "{{count}} videos watched",
      "clearHistory": "Clear history",
      "clearHistoryConfirm": "Clear your YouTube watch history?",
      "live": "LIVE",
      "views": "{{count}} views",
      "viewsShort": "{{count}}",
      "searchOnYouTube": "Search on YouTube",
      "searchingYouTube": "Searching YouTube…",
      "externalResults": "Results from YouTube",
      "externalBadge": "From YouTube",
      "clearExternal": "Hide YouTube results",
      "searchError": "YouTube search failed: {{error}}",
      "save": "Save for later",
      "saved": "Saved — open from your Saved view"
    },
    "health": {
      "title": "Source health",
      "healthy": "Healthy",
      "degraded": "Degraded",
      "failing": "Failing",
      "disabled": "Disabled",
      "articles7d": "{{count}} in 7d",
      "lastFetched": "{{time}} ago",
      "failures": "{{count}} fails",
      "enable": "Enable",
      "disable": "Disable",
      "emptyFilter": "No sources match this filter.",
      "notOwnerTitle": "Owner only",
      "notOwnerDescription": "Source health is restricted to the deployment owner.",
      "refreshTags": "Refresh tags",
      "enriching": "Tagging…",
      "refreshTagsHint": "Manually trigger tag classification.",
      "refreshTagsResult": "Tagged {{tagged}}/{{processed}} via {{providers}}",
      "filter": {
        "all": "All",
        "problems": "Problems",
        "disabled": "Disabled"
      }
    },
    "lang": {
      "label": "Language",
      "all": "All languages",
      "ar": "عربى",
      "en": "English"
    },
    "sourceKind": {
      "label": "Source",
      "all": "All sources",
      "news": "News",
      "reddit": "Reddit",
      "youtube": "YouTube",
      "mastodon": "Mastodon",
      "bluesky": "Bluesky"
    },
    "subSource": {
      "label": "Specific source",
      "all": "All"
    },
    "category": {
      "label": "Category",
      "all": "All",
      "world": "World",
      "ai": "AI",
      "tech": "Tech",
      "science": "Science",
      "sports": "Sports",
      "rights": "Rights",
      "local": "Local",
      "business": "Business"
    },
    "recentMatches": "Recent matches",
    "viewAllMatches": "View all",
    "tag": {
      "breaking": "Breaking",
      "analysis": "Analysis",
      "interview": "Interview",
      "listicle": "Listicle",
      "review": "Review",
      "announcement": "Announcement",
      "video": "Video",
      "social": "Social",
      "science": "Science",
      "sports": "Sports",
      "politics": "Politics",
      "finance": "Finance",
      "tech": "Tech"
    },
    "article": {
      "notFound": "Article not found.",
      "aiSummary": "AI summary",
      "aiSummaryTranslate": "Translate summary",
      "aiSummaryShowOriginal": "Show original summary",
      "noSummary": "No excerpt available — open on the source site to read the full article.",
      "noSocialBody": "Post text wasn't captured. Open on source to read the full post.",
      "loadingContent": "Fetching the full article…",
      "extractFailed": "Couldn't extract the full article. Showing the RSS excerpt instead.",
      "fallbackExcerpt": "RSS excerpt:",
      "refetch": "Re-fetch content",
      "readFullOnSource": "Open on {{source}}",
      "source": "the source",
      "save": "Save for later",
      "unsave": "Remove from saved",
      "muteSource": "Mute {{source}}",
      "unmuteSource": "Unmute {{source}}",
      "similarTitle": "Similar articles",
      "readingMinutes_one": "{{count}} min read",
      "readingMinutes_other": "{{count}} min read",
      "ttsPlay": "Listen",
      "ttsPause": "Pause listening",
      "ttsResume": "Resume listening",
      "ttsStop": "Stop listening",
      "translateAction": "Translate this article",
      "translating": "Translating to your language…",
      "translatedAuto": "Translated",
      "translationFailed": "Translation failed",
      "showOriginal": "Show original",
      "showTranslation": "Show translation",
      "retry": "Retry"
    }
  },
  "sports": {
    "title": "Matches",
    "filterAll": "All leagues",
    "filterFavourites": "Favourites",
    "filterMyTeams": "My teams",
    "filterMyTeamsHint_one": "Show only matches involving 1 favourite team",
    "filterMyTeamsHint_other": "Show only matches involving {{count}} favourite teams",
    "favourite": "Add to favourites",
    "unfavourite": "Remove from favourites",
    "leaguesLabel": "Leagues",
    "myTeamsLabel": "My teams",
    "filtersOpen": "Open filters",
    "viewStandings": "Table",
    "tableMissing": "Sports isn't ready yet. Check back in a minute.",
    "groups": {
      "live": "Live",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "later": "Coming up"
    },
    "empty": {
      "title": "No matches yet",
      "description": "Sit tight — fixtures appear here once the cron has pulled them.",
      "descriptionTeams": "None of your favourite teams have a match in the next 7 days."
    },
    "hero": {
      "title": "Your team next up",
      "soon": "Kicking off soon",
      "inHours_one": "In about an hour",
      "inHours_other": "In about {{count}} hours",
      "inDays_one": "Tomorrow",
      "inDays_other": "In {{count}} days"
    },
    "match": {
      "title": "Match",
      "notFound": "Match not found.",
      "matchday": "Matchday {{n}}",
      "kickoff": "Kickoff",
      "goals": "Goals",
      "form": "Recent form",
      "h2h": "Head-to-head",
      "played": "Played",
      "addToCalendar": "Add to calendar",
      "relatedNews": "Related news",
      "lineupsUnavailable": "Lineups aren't available on the free data plan.",
      "statusLive": "Live",
      "statusFinished": "Full time",
      "statusScheduled": "Scheduled",
      "statusPostponed": "Postponed",
      "statusCancelled": "Cancelled"
    },
    "team": {
      "title": "Team",
      "notFound": "Team not found.",
      "website": "Website",
      "colours": "Colours",
      "competitions": "Competitions",
      "upcoming": "Upcoming matches",
      "recent": "Recent matches",
      "squad_one": "Squad — 1 player",
      "squad_other": "Squad — {{count}} players",
      "home": "Home",
      "away": "Away"
    },
    "standings": {
      "title": "Standings",
      "team": "Team",
      "topScorers": "Top scorers",
      "empty": "No standings available for this competition right now."
    }
  },
  "reports": {
    "title": "Reports",
    "subtitle": "Cross-module markdown report for any date range.",
    "preset": "Preset",
    "presets": {
      "thisWeek": "This week",
      "last7": "Last 7 days",
      "thisMonth": "This month",
      "last30": "Last 30 days",
      "custom": "Custom"
    },
    "startDate": "Start",
    "endDate": "End",
    "generate": "Generate report",
    "includes": "Each report includes:",
    "includesWorkout": "Workout — sessions, volume, work sets, cardio minutes",
    "includesPhoenix": "Phoenix — weight delta, water hit rate, meal logs, avg kcal/protein",
    "includesHealth": "Health — medication & supplement adherence, latest vitals",
    "includesFinance": "Finance — balance trend, income, expenses, installments, monthly net, targets",
    "includesVitals": "Vitals — blood pressure, heart rate, glucose timeline",
    "includesPhases": "Phases — active phase, history, weight goals",
    "includesLearning": "Learning — saved resources grouped by topic",
    "includesJourney": "Journey — private recovery log, resistance rate, daily check-ins",
    "formatHint": "Opens as a full-screen preview. Tap Print to save as PDF, or Download to keep the .html file.",
    "preview": "Report preview",
    "print": "Print",
    "download": "Download",
    "missingTables": "Report generated. Some sections were skipped because these tables aren't deployed yet: {{tables}}. Apply the matching migration to include them."
  },
  "immigration": {
    "title": "Immigration",
    "subtitle": "Research countries and track your path",
    "empty": "No countries seeded yet.",
    "notFound": "Country not found.",
    "openTracker": "Open tracker",
    "assistant": {
      "title": "Immigration AI",
      "cta": "Ask AI",
      "askAboutCountry": "Ask AI about {{country}}",
      "subtitlePerCountry": "Ask anything specific to this country — visas, timelines, your eligibility",
      "intro": "Ask anything about your immigration plan — I have your profile, finances, and tracked countries as context.",
      "placeholder": "Ask anything…"
    },
    "pathway": {
      "title": "Step-by-step pathway",
      "subtitle": "Walk through the application start-to-finish. Tap \"Track\" on any step to copy it into your milestones, or \"View details\" for the full deep-dive.",
      "trackThis": "Track",
      "alreadyTracking": "Tracking",
      "viewDetails": "View details"
    },
    "step": {
      "shortLabel": "Step {{n}}",
      "vendors": "Recommended providers",
      "pitfalls": "Common pitfalls",
      "tips": "Tips from applicants",
      "generating": "Generating deep-dive… this only happens the first time, then it's cached.",
      "generatedOn": "Generated {{date}}",
      "fresh": "fresh",
      "refresh": "Regenerate"
    },
    "tracker": {
      "subtitle": "Documents, milestones, and costs",
      "docs": {
        "title": "Documents",
        "empty": "No documents yet — add the first one.",
        "namePlaceholder": "e.g. IELTS Academic, Degree apostille…",
        "expires": "expires",
        "sharedAcrossCountries": "Applies to all countries (e.g. passport)"
      },
      "docStatus": {
        "not_started": "Not started",
        "in_progress": "In progress",
        "obtained": "Obtained",
        "expired": "Expired"
      },
      "docCategory": {
        "identity": "Identity",
        "education": "Education",
        "language": "Language",
        "experience": "Experience",
        "financial": "Financial",
        "medical": "Medical",
        "general": "General"
      },
      "milestones": {
        "title": "Milestones",
        "empty": "No milestones yet — add a target date.",
        "namePlaceholder": "e.g. Take IELTS, Submit Express Entry profile…",
        "target": "target",
        "done": "done"
      },
      "milestoneStatus": {
        "planned": "Planned",
        "in_progress": "In progress",
        "completed": "Completed",
        "blocked": "Blocked"
      },
      "costs": {
        "title": "Costs",
        "empty": "No costs yet — add a planned or paid expense.",
        "namePlaceholder": "e.g. IELTS fee, WES evaluation…",
        "amountPlaceholder": "Amount in SAR",
        "alreadyPaid": "Already paid",
        "markPaid": "Mark as paid",
        "markUnpaid": "Mark as unpaid",
        "totals": "Paid / Total"
      },
      "costCategory": {
        "visa_fee": "Visa fee",
        "translation": "Translation",
        "exam": "Exam",
        "apostille": "Apostille",
        "travel": "Travel",
        "consultancy": "Consultancy",
        "equipment": "Equipment",
        "other": "Other"
      }
    },
    "tolerance": "Tolerance",
    "stability": "Stability",
    "years": "yrs",
    "statusLabel": "Status",
    "quickFacts": "Quick facts",
    "citizenshipPath": "Citizenship path",
    "languages": "Languages",
    "monthlyCost": "Monthly living cost",
    "dualCitizenship": "Dual citizenship",
    "visaPaths": "Main visa paths",
    "pros": "Pros",
    "cons": "Considerations",
    "officialLinks": "Official links",
    "notes": "My notes",
    "notesPlaceholder": "Private notes about this country…",
    "pin": "Pin",
    "unpin": "Unpin",
    "status": {
      "researching": "Researching",
      "interested": "Interested",
      "pursuing": "Pursuing",
      "not_interested": "Not for me"
    }
  },
  "dues": {
    "title": "Next month's dues",
    "empty": "Nothing to settle for next month.",
    "netTotal": "Net to apply",
    "confirmSelected": "Pay {{count}}",
    "newBalance": "New balance",
    "success": "Confirmed {{count}} entries",
    "statusUnsettled": "Due day {{day}}",
    "statusPending": "Awaiting review",
    "statusConfirmed": "Paid for next month",
    "kind": {
      "installment": "Installments",
      "fixed_expense": "Fixed expenses",
      "special_obligation": "Special obligations",
      "income": "Income"
    },
    "banner": {
      "title_one": "{{count}} item due next month",
      "title_other": "{{count}} items due next month",
      "title": "{{count}} items due next month",
      "subtitle": "Tap to review and prepay"
    }
  },
  "finance": {
    "title": "Finance",
    "audit": {
      "title": "Recurring audit",
      "run": "Analyze",
      "rerun": "Re-run",
      "hint": "AI looks over your fixed expenses, installments and obligations — what's dormant, overpriced or ending soon.",
      "failed": "Audit failed — try again.",
      "empty": "No recurring expenses to audit yet.",
      "recurringTotal": "Monthly recurring:",
      "ofIncome": "of income:"
    },
    "dashboard": {
      "currentBalance": "Current balance",
      "asOf": "as of {{date}}",
      "editBalance": "Edit balance",
      "monthlyIncome": "Monthly income",
      "monthlyOutflow": "Monthly outflow",
      "monthlyInstallments": "Installments",
      "monthlyNet": "Monthly net",
      "expectedEnd": "Expected end of month: {{amount}} SAR",
      "risk": {
        "safe": "Safe zone",
        "warning": "Stay alert",
        "critical": "Risk zone"
      }
    },
    "balance": {
      "amount": "Amount (SAR)",
      "date": "As-of date",
      "notes": "Notes (optional)",
      "notesPlaceholder": "e.g. after salary",
      "history": "Balance history"
    },
    "income": {
      "title": "Income",
      "add": "Add income",
      "empty": "No income sources yet.",
      "name": "Source name",
      "amount": "Amount",
      "receiveDay": "Day of month",
      "confirmDelete": "Delete this income source?",
      "frequencies": {
        "monthly": "Monthly",
        "yearly": "Yearly",
        "one_time": "One-time"
      }
    },
    "fixed": {
      "title": "Fixed expenses",
      "add": "Add expense",
      "empty": "No fixed expenses yet.",
      "name": "Expense name",
      "amount": "Amount",
      "chargeDay": "Charge day of month",
      "chargeDayShort": "day {{day}}",
      "confirmDelete": "Delete this expense?",
      "categories": {
        "family": "Family",
        "transportation": "Transport",
        "utilities": "Utilities",
        "subscriptions": "Subscriptions",
        "other": "Other"
      }
    },
    "variable": {
      "title": "Variable expenses",
      "amount": "Monthly estimate (SAR)",
      "notes": "What this covers"
    },
    "installments": {
      "title": "Installments",
      "add": "Add installment",
      "empty": "No active installments.",
      "provider": "Provider",
      "label": "Label (optional)",
      "monthlyAmount": "Monthly amount",
      "remaining": "Months left",
      "total": "Total months",
      "day": "Day",
      "monthsLeft": "left",
      "lastMonth": "Last month",
      "confirmDelete": "Delete this installment?"
    },
    "obligations": {
      "title": "Special obligations",
      "add": "Add obligation",
      "empty": "No special obligations.",
      "name": "Name",
      "amount": "Amount",
      "totalMonths": "Total months",
      "remainingMonths": "Remaining",
      "startDate": "Start date",
      "endDate": "End date",
      "nextPaymentDate": "Next payment",
      "nextPayment": "Next payment",
      "payoutStatus": "Payout status",
      "payoutDate": "Payout date",
      "goalLink": "Linked goal",
      "notes": "Notes",
      "monthsPaid": "months paid",
      "confirmDelete": "Delete this obligation?",
      "kinds": {
        "swimming": "Swimming",
        "jam3eya": "Jam3eya",
        "rent": "Rent",
        "custom": "Custom"
      },
      "frequencies": {
        "monthly": "Monthly",
        "every_6_months": "Every 6 months",
        "one_time": "One-time"
      },
      "payoutStatuses": {
        "pending": "Pending",
        "received": "Received"
      }
    },
    "forecast": {
      "title": "12-month forecast",
      "viewTable": "Table",
      "viewChart": "Chart",
      "income": "Income",
      "fixed": "Fixed",
      "variable": "Variable",
      "installments": "Installments",
      "obligations": "Obligations",
      "net": "Net",
      "balance": "Balance",
      "lastDeduction": "Last",
      "chartLegend": "Cumulative balance · dashed lines = 5k / 1k thresholds"
    },
    "targets": {
      "title": "Targets",
      "achievementsTitle": "Achievements",
      "add": "Add target",
      "empty": "No active targets.",
      "name": "Target name",
      "targetValue": "Target amount (SAR)",
      "targetDate": "Target by",
      "expectedBy": "Expected by",
      "achievedOn": "Achieved on",
      "markAchieved": "Mark as achieved",
      "missed": "Missed",
      "notesPlaceholder": "Notes (optional)",
      "confirmAchieve": "Mark this target as achieved?",
      "confirmDelete": "Delete this target?",
      "types": {
        "balance_threshold": "Balance threshold",
        "obligation_complete": "Obligation done",
        "all_installments_complete": "All installments cleared",
        "all_obligations_complete": "All obligations cleared",
        "ongoing_rule": "Ongoing rule",
        "custom": "Custom"
      }
    },
    "alerts": {
      "forecast": {
        "critical": "Risk zone ahead",
        "warning": "Stay alert",
        "body": "Expected balance at end of {{month}}: {{amount}} SAR"
      },
      "upcoming": {
        "installmentTitle": "{{label}} deduction coming up",
        "obligationTitle": "{{label}} payment coming up"
      }
    },
    "upcoming": {
      "title": "Next 30 days",
      "today": "today",
      "tomorrow": "tomorrow",
      "daysAway": "days away"
    },
    "balanceChart": {
      "title": "Balance over time",
      "balance": "Balance"
    }
  },
  "healthProfile": {
    "title": "Health profile",
    "todayDoses": {
      "title": "Today's doses"
    },
    "medication": {
      "title": "Medications",
      "add": "Add medication",
      "empty": "No medications yet.",
      "name": "Name",
      "dosage": "Dose",
      "frequency": "Frequency",
      "scheduleTimes": "Times of day",
      "scheduleHint": "24-hour, comma-separated (e.g. 08:00, 20:00)",
      "startedAt": "Started on",
      "reminders": "Send reminders at scheduled times",
      "notes": "Notes",
      "confirmDelete": "Delete this medication?",
      "streak": "{{n}}",
      "streakA11y": "{{n}} day streak",
      "frequencies": {
        "daily": "Daily",
        "twice_daily": "Twice daily",
        "three_daily": "Three times daily",
        "weekly": "Weekly",
        "as_needed": "As needed"
      }
    },
    "supplement": {
      "title": "Vitamins & supplements",
      "add": "Add supplement",
      "empty": "No supplements yet.",
      "name": "Name",
      "dosage": "Dose",
      "frequency": "Frequency",
      "scheduleTimes": "Times of day",
      "scheduleHint": "24-hour, comma-separated (e.g. 08:00, 20:00)",
      "startedAt": "Started on",
      "reminders": "Send reminders at scheduled times",
      "notes": "Notes",
      "confirmDelete": "Delete this supplement?",
      "streak": "{{n}}",
      "streakA11y": "{{n}} day streak",
      "frequencies": {
        "daily": "Daily",
        "twice_daily": "Twice daily",
        "three_daily": "Three times daily",
        "weekly": "Weekly",
        "as_needed": "As needed"
      }
    },
    "vitals": {
      "title": "Vitals",
      "addReading": "Add reading",
      "empty": "No readings logged yet.",
      "confirmDelete": "Delete this reading?",
      "notes": "Notes",
      "context": {
        "label": "Context",
        "fasting": "Fasting",
        "pre_meal": "Pre-meal",
        "post_meal": "Post-meal",
        "before_bed": "Before bed",
        "other": "Other"
      },
      "bp": {
        "title": "Blood pressure",
        "systolic": "Systolic",
        "diastolic": "Diastolic",
        "unit": "mmHg"
      },
      "hr": {
        "title": "Resting heart rate",
        "bpm": "BPM"
      },
      "glucose": {
        "title": "Blood glucose",
        "value": "Value",
        "unit": "mg/dL"
      }
    },
    "condition": {
      "title": "Conditions",
      "add": "Add condition",
      "empty": "No conditions logged.",
      "name": "Name",
      "diagnosedAt": "Diagnosed",
      "doctor": "Doctor",
      "active": "Currently active",
      "notes": "Notes",
      "confirmDelete": "Delete this condition?"
    }
  },
  "breadcrumb": {
    "label": "Breadcrumb",
    "home": "Home",
    "workout": "Workout",
    "history": "History",
    "session": "Session",
    "library": "Library",
    "exercise": "Exercise",
    "templates": "Templates",
    "newSession": "New session",
    "phases": "Phases",
    "settings": "Settings",
    "profile": "Profile",
    "habits": "Habits",
    "physique": "Physique check",
    "sleep": "Sleep realignment",
    "goalPace": "Goal Pace",
    "quizHistory": "History",
    "editProfile": "Edit profile",
    "news": "News",
    "social": "Social",
    "tech": "Tech",
    "newsHealth": "Source health",
    "article": "Article",
    "gamesWordle": "Wordle",
    "gamesQuestions": "Questions",
    "gamesQuiz": "Quiz",
    "gamesSpy": "Spy",
    "scoreboard": "Scoreboard",
    "youtube": "YouTube",
    "health": "Health profile",
    "learning": "Learning",
    "english": "English",
    "englishVocab": "Vocabulary",
    "englishReview": "Review",
    "englishCourse": "Course",
    "englishTutor": "Tutor",
    "englishSpeak": "Speak",
    "messages": "Inbox",
    "message": "Message",
    "friends": "Friends",
    "lifeSearch": "Life Search",
    "people": "People",
    "wishlist": "Wishlist",
    "moments": "Moments",
    "momentsCapture": "Camera",
    "momentsArchive": "History",
    "momentsDay": "Day",
    "momentsDigest": "Monthly recap",
    "reading": "Reading",
    "readingNew": "Add book",
    "readingBook": "Book",
    "readingRecap": "Quarterly recap",
    "readingCatalog": "Free books",
    "readingRead": "Reading",
    "tab": {
      "today": "Today",
      "weight": "Weight",
      "water": "Water",
      "meals": "Meals",
      "measurements": "Measurements",
      "photos": "Photos",
      "progress": "Progress"
    }
  },
  "settings": {
    "title": "Settings",
    "back": "Back",
    "close": "Close",
    "crumb": "Settings",
    "replayTour": "Replay the tour",
    "sections": {
      "preferences": "Preferences",
      "appearance": "Appearance",
      "voice": "Voice",
      "briefing": "Morning briefing",
      "notifications": "Notifications",
      "profile": "Profile",
      "training": "Training",
      "app": "App",
      "developer": "Developer"
    },
    "briefing": {
      "location": "Weather location",
      "current": "Current:",
      "cityPlaceholder": "Search a city… \"Jeddah\"",
      "useGps": "Use my location",
      "myLocation": "My location",
      "sectionsTitle": "What to include",
      "sections": {
        "weather": "Weather",
        "news": "News",
        "finance": "Finance",
        "training": "Training",
        "habits": "Habits",
        "goals": "Goals"
      },
      "interestsTitle": "News interests",
      "interestsHint": "Comma-separated topics — the briefing only mentions headlines matching them.",
      "interestsPlaceholder": "tech, football, AI…"
    },
    "app": {
      "checkUpdates": {
        "label": "Check for updates",
        "description": "Force the app to grab the latest build. Use this if you've been told a new feature shipped but you don't see it yet — the page reloads after ~3 seconds."
      }
    },
    "voice": {
      "englishLabel": "English voice",
      "englishSample": "Hi! This is a sample of my voice — tap me on a vocab card to hear me read.",
      "arabicLabel": "Arabic voice",
      "arabicSample": "أهلاً! ده مثال من صوتى. اضغط على أى كلمة فى التطبيق علشان تسمعنى.",
      "previewing": "Previewing…"
    },
    "developer": {
      "aiDebug": {
        "label": "AI debug panel",
        "description": "Show the raw status, headers, and response body under each AI card. Useful when an AI call fails on mobile."
      },
      "aiThinking": {
        "label": "AI thinking",
        "description": "Let the model reason before answering. ~4× cost and 4-9s slower, marginal quality gain on simple prompts. Off by default."
      },
      "showAiProvider": {
        "label": "Show AI provider",
        "description": "Reveal the model name (gemini / groq / cerebras) under each AI response. Owner-only debug aid — off by default."
      },
      "debugLog": {
        "label": "On-device debug log",
        "description": "Capture console output, errors, and uncaught exceptions to a persistent in-app log so you can copy + share it with me when iOS Safari isn't telling you what broke."
      },
      "testUpdate": {
        "label": "Trigger update prompt",
        "description": "Fire a fake pwa:update-available event so the centered Update modal renders right now. Tap to verify the non-dismissible contract end-to-end; clicking Update reloads the page after ~3s."
      },
      "testCelebration": {
        "label": "Test win celebration",
        "description": "Fire the same confetti burst Wordle plays when you solve the daily — twin angled bursts from the bottom corners plus a softer mid-air pop ~300ms later. Useful for tuning the palette + density."
      },
      "sendPush": {
        "section": "Send a notification",
        "recipient": "Recipient",
        "title": "Title",
        "titlePlaceholder": "e.g. \"Quick check-in\"",
        "body": "Message",
        "bodyPlaceholder": "Whatever you want to say.",
        "url": "Open this URL on tap",
        "send": "Send",
        "sending": "Sending…"
      }
    },
    "appearance": {
      "theme": "Theme",
      "themeLight": "Light",
      "themeDark": "Dark",
      "themeBlack": "Black",
      "autoTheme": "Switch by time of day",
      "autoThemeHint": "Light from 6 AM to 6 PM, dark in the evening.",
      "autoThemeNightHint": "Used at night — daytime always paints light.",
      "primaryColor": "Primary colour",
      "font": "Font"
    }
  },
  "reminders": {
    "title": "Daily reminder",
    "description": "We'll nudge you once a day to check in.",
    "time": "At",
    "enable": "Enable reminders",
    "disable": "Disable reminders",
    "permissionBlocked": "Notifications are blocked. Enable them in your browser settings.",
    "iosInstallRequired": "Install the app to your home screen to enable reminders on iOS.",
    "sendTest": "Send test",
    "testSent": "Test sent — check your notifications.",
    "testFailed": "Test failed: {{detail}}",
    "showLocal": "Show local",
    "localTestBody": "If you see this banner, iOS notifications are working.",
    "localTestSent": "Local notification fired — check your screen.",
    "localTestFailed": "Local notification failed: {{detail}}",
    "diagnostics": {
      "title": "Status",
      "permission": "Browser permission",
      "permission_granted": "Granted",
      "permission_denied": "Blocked — unblock from site settings",
      "permission_default": "Not asked yet",
      "subscribed": "Subscription on file",
      "subscribed_yes": "Active",
      "subscribed_no": "Not subscribed — tap Enable above",
      "testLocal": "Test on this device"
    },
    "moreKinds": "More reminders",
    "kinds": {
      "meals": {
        "title": "Log your meals",
        "subtitle": "Ping in the evening if you haven't logged anything",
        "enable": "Enable meal reminder",
        "disable": "Disable meal reminder"
      },
      "water": {
        "title": "Drink your water",
        "subtitle": "Ping if you're behind on your daily goal",
        "enable": "Enable water reminder",
        "disable": "Disable water reminder"
      },
      "birthday": {
        "title": "Birthday",
        "subtitle": "We'll say hi at noon",
        "enable": "Enable birthday reminder",
        "disable": "Disable birthday reminder"
      },
      "sleep": {
        "title": "Sleep realignment",
        "subtitle": "Melatonin, wind-down & wake-up nudges on plan time",
        "enable": "Enable sleep reminders",
        "disable": "Disable sleep reminders"
      }
    }
  },
  "profile": {
    "openMenu": "Open profile menu",
    "greeting": "Hello, {{name}} 👋",
    "fallbackName": "friend",
    "ageLine": "Age {{age}} · Birthday in {{days}} days",
    "ageLineToday": "Age {{age}} · Happy birthday! 🎂",
    "completeProfile": "Complete your profile →",
    "userId": "User ID",
    "themeLight": "Light mode",
    "themeDark": "Dark mode",
    "editProfile": "Edit profile / goals",
    "workouts": "Workouts",
    "measurements": "Measurements",
    "signOut": "Sign out",
    "avatar": {
      "title": "Profile photo",
      "pickPrompt": "Pick a photo to upload.",
      "pick": "Pick photo",
      "pickAnother": "Pick different",
      "previewHint": "The photo will be center-cropped to a square.",
      "save": "Use this photo",
      "uploading": "Uploading…",
      "saveFailed": "Couldn't upload — check your connection and try again."
    },
    "editPage": {
      "title": "Profile",
      "changePhoto": "Change photo",
      "name": "Name",
      "namePh": "What should we call you?",
      "birthday": "Birthday",
      "sex": "Sex",
      "sex_male": "Male",
      "sex_female": "Female",
      "sex_other": "Other",
      "height": "Height ({{unit}})",
      "save": "Save changes",
      "saving": "Saving…",
      "saved": "Saved"
    }
  },
  "workout": {
    "title": "Workout",
    "subtitle": "Train smart, log fast.",
    "uploading": "Uploading…",
    "dashboard": {
      "firstRunTitle": "Set up your library",
      "firstRunDesc": "We'll seed default exercises for Day 1, 2, and 3 so you can start logging right away.",
      "setupCta": "Seed default exercises",
      "seeding": "Seeding…",
      "libraryCard": "Exercise library",
      "libraryCardDesc": "{{count}} exercises",
      "startCard": "Start a workout",
      "startCardDesc": "Log sets, cardio, and how it felt.",
      "historyCard": "Session history",
      "historyCardDesc": "Browse past sessions",
      "templatesCard": "Templates",
      "templatesCardDesc": "Edit your Day 1/2/3 lineups"
    },
    "history": {
      "title": "Session history",
      "subtitle": "Newest first.",
      "empty": "No sessions yet — start your first workout from the dashboard.",
      "summary": "{{exercises}} ex · {{sets}} sets · {{volume}} kg",
      "summaryCardio": "{{cardio}} min cardio",
      "duration": "{{min}} min",
      "bodyWeight": "{{kg}} kg bw",
      "exportMarkdown": "Export as Markdown"
    },
    "sessionDetail": {
      "title": "Session",
      "notFound": "Session not found",
      "edit": "Edit session",
      "delete": "Delete session",
      "totalCalories": "Total calories",
      "confirmDelete": "Delete this session?",
      "confirmDeleteDesc": "All sets and cardio records for this session will be removed.",
      "saveAsTemplate": "Save as template",
      "saveAsTemplateConfirm": "Replace the {{day}} template?",
      "saveAsTemplateConfirmDesc": "Future {{day}} sessions will start with the exercises from this session, in the same order.",
      "saveAsTemplateSuccess": "Saved as template",
      "saveAsTemplateError": "Couldn't save template",
      "notes": "Notes",
      "energyLabel": "Energy",
      "bodyWeight": "Body weight",
      "duration": "Duration",
      "startTime": "Start time",
      "exercises": "Exercises",
      "cardio": "Cardio",
      "noLogs": "No exercises logged",
      "warmupTag": "Warm-up",
      "failureTag": "Failure"
    },
    "templates": {
      "title": "Templates",
      "subtitle": "Pick what loads when you start a Day 1/2/3 session.",
      "day1_chest_back": "Day 1 — Chest & Back",
      "day2_arms_shoulders": "Day 2 — Shoulders & Arms",
      "day3_legs": "Day 3 — Legs",
      "empty": "No exercises yet — add one.",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "remove": "Remove",
      "add": "Add exercise",
      "saving": "Saving…"
    },
    "pr": {
      "title": "Personal records",
      "heaviest": "Heaviest",
      "bestSet": "Best set",
      "mostReps": "Most reps",
      "heaviestValue": "{{weight}} kg × {{reps}}",
      "bestSetValue": "{{volume}} kg",
      "mostRepsValue": "{{reps}} × {{weight}} kg"
    },
    "chart": {
      "title": "Progression",
      "yAxis": "kg",
      "tooltipTop": "Top set: {{weight}} kg × {{reps}}",
      "notEnoughData": "Log at least 2 sessions to see your progression chart.",
      "recentSessions": "Recent sessions",
      "noRecent": "No sessions yet."
    },
    "session": {
      "title": "New session",
      "editTitle": "Edit session",
      "pickType": "Pick a session type",
      "save": "Save session",
      "saving": "Saving…",
      "savedToast": "Session saved",
      "updatedToast": "Session updated",
      "resumePromptTitle": "Resume previous draft?",
      "resumePromptDesc": "You have an unsaved session from earlier.",
      "resume": "Resume",
      "discard": "Discard",
      "addExercise": "Add exercise",
      "addCardio": "Add cardio",
      "removeExercise": "Remove exercise",
      "removeExerciseConfirm": "Remove this exercise from the session?",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "exerciseNotes": "Exercise notes",
      "exerciseNotesPlaceholder": "Form cues, tempo, etc.",
      "previewExercise": "Preview {{name}}",
      "lastSet": "Last: {{weight}}kg × {{reps}}",
      "noHistory": "No history yet",
      "recentSessions": "Last 3 sessions",
      "emptyError": "Add at least one exercise or cardio block.",
      "saveError": "Couldn't save session: {{message}}",
      "missingExercise": "(missing — removed from library)"
    },
    "sessionType": {
      "day1_chest_back": "Day 1 — Chest & Back",
      "day1_chest_back_desc": "Chest + back",
      "day2_arms_shoulders": "Day 2 — Shoulders & Arms",
      "day2_arms_shoulders_desc": "Shoulders, biceps, triceps",
      "day3_legs": "Day 3 — Legs",
      "day3_legs_desc": "Quads, hamstrings, calves, core",
      "swim": "Swim",
      "swim_desc": "Pool training",
      "cardio_only": "Cardio only",
      "cardio_only_desc": "Skip strength, log cardio blocks",
      "custom": "Custom",
      "custom_desc": "Build your own from scratch"
    },
    "set": {
      "header": "#",
      "weight": "Weight (kg)",
      "reps": "Reps",
      "rpe": "RPE",
      "warmup": "Warmup",
      "failure": "Failure",
      "add": "Add set",
      "remove": "Remove set",
      "invalidReps": "Reps must be greater than 0"
    },
    "cardio": {
      "title": "Cardio",
      "type": "Type",
      "duration": "Duration (min)",
      "level": "Level",
      "incline": "Incline (%)",
      "speed": "Speed (km/h)",
      "distance": "Distance (km)",
      "calories": "Calories",
      "notes": "Notes",
      "notesPlaceholder": "Anything worth remembering…",
      "invalidDuration": "Duration must be greater than 0"
    },
    "cardioType": {
      "elliptical": "Elliptical",
      "treadmill_walk": "Treadmill — walk",
      "treadmill_run": "Treadmill — run",
      "treadmill_intervals": "Treadmill — intervals",
      "bike": "Stationary bike",
      "stairmaster": "Stairmaster",
      "swim": "Swim"
    },
    "cardioPresets": {
      "title": "Quick plans",
      "hrBadge": "≤{{bpm}} BPM"
    },
    "meta": {
      "toggle": "Session details",
      "bodyWeight": "Body weight (kg)",
      "bodyWeightHint": "Pre-filled from your last entry",
      "energy": "Energy (1-10)",
      "startTime": "Start time",
      "duration": "Duration (min)",
      "notes": "Session notes",
      "notesPlaceholder": "How did it feel?"
    },
    "picker": {
      "title": "Pick an exercise",
      "close": "Close",
      "empty": "Your library is empty — seed defaults from the dashboard first."
    },
    "exercises": {
      "title": "Exercises",
      "subtitle": "Your library of moves and machines.",
      "addNew": "Add",
      "edit": "Edit",
      "archive": "Archive exercise",
      "confirmArchive": "Archive this exercise?",
      "confirmArchiveDesc": "It'll be hidden from the library. Past sets that referenced it stay intact.",
      "searchPlaceholder": "Search…",
      "filterAll": "All",
      "noResults": "No exercises match.",
      "notFound": "Exercise not found",
      "noPhoto": "No photo yet — tap Edit to add one.",
      "form": {
        "name": "Name",
        "muscleGroup": "Muscle group",
        "equipmentType": "Equipment",
        "photo": "Machine photo",
        "uploadPhoto": "Tap to upload a photo",
        "setupNotes": "Setup notes",
        "setupPlaceholder": "Seat height, angle, hand position…",
        "save": "Save"
      },
      "detail": {
        "setupNotes": "Setup notes",
        "historyComingSoon": "Progression chart and history arrive in the next release."
      }
    },
    "muscleGroup": {
      "chest": "Chest",
      "back": "Back",
      "shoulders": "Shoulders",
      "biceps": "Biceps",
      "triceps": "Triceps",
      "quads": "Quads",
      "hamstrings": "Hamstrings",
      "glutes": "Glutes",
      "core": "Core",
      "full_body": "Full body"
    },
    "equipment": {
      "barbell": "Barbell",
      "dumbbell": "Dumbbell",
      "machine": "Machine",
      "cable": "Cable",
      "bodyweight": "Bodyweight",
      "smith": "Smith"
    }
  },
  "loadingPage": {
    "title": "Rising...",
    "subtitle": "Lighting up your Phoenix Tracker"
  },
  "physique": {
    "title": "Physique check",
    "album": {
      "title": "Progress album",
      "empty": "Add private progress photos over time — then pick any two and the AI narrates what actually changed.",
      "compare": "Compare the two selected",
      "failed": "Comparison failed — try again.",
      "pose": {
        "front": "Front",
        "side": "Side",
        "back": "Back"
      }
    },
    "intro": "Send a photo and get an AI read on what to focus on.",
    "pick": "Choose a photo",
    "tryAnother": "Try another photo",
    "analyzing": "Analyzing…",
    "privacy": "Your photo isn't stored — it's analyzed and discarded.",
    "strengths": "Strong points",
    "focusAreas": "Focus on",
    "tips": "Training tips",
    "history": "Past checks",
    "failed": "Couldn't analyze that — try a clearer full-body photo.",
    "notPerson": "That doesn't look like a body photo. Try a clear full-body shot.",
    "disclaimer": "AI guidance for training only — not medical or health advice."
  },
  "goalPace": {
    "title": "Goal Pace",
    "settings": "Settings",
    "sevenDayAvg": "7-day average weight",
    "daysLeft": "{{n}} days left",
    "todayRaw": "today {{v}}",
    "weeklyRate": "Weekly rate",
    "bandHint": "Healthy band: {{min}}–{{max}} {{unit}}/week",
    "projected": "Projected at target date:",
    "chartTitle": "Weekly average vs target",
    "avgLine": "7-day avg",
    "targetLine": "Target",
    "levers": "Daily levers",
    "steps": "Steps",
    "stepTarget": "Target {{min}}–{{max}}",
    "logSteps": "Log today's steps",
    "today": "Today",
    "avg7": "7-day avg",
    "protein": "Protein",
    "proteinTarget": "Target {{g}} g/day",
    "streak": "Streak",
    "buildingBaseline": "Building your baseline",
    "buildingBaselineHint": "{{n}} of {{need}} weigh-ins. Keep logging — a trend needs a couple of weeks before it means anything.",
    "targetDate": "Target date",
    "baselineWeight": "Baseline weight ({{unit}})",
    "baselineDate": "Baseline date",
    "goalWeight": "Goal weight ({{unit}})",
    "optional": "optional",
    "note": {
      "tooFast": "Loss has run faster than the sustainable band for 2+ weeks. That raises the risk of muscle and energy loss — consider easing the deficit. Faster isn't better here.",
      "aggressive": "This goal needs a faster-than-healthy rate for the time left. A realistic weight by your target date is about {{weight}}. The date isn't a wall — it's just the honest projection.",
      "behind": "A little behind the pace. The lever is more daily steps and hitting your protein target — not eating less."
    }
  },
  "sleep": {
    "title": "Sleep realignment",
    "endPlan": "End plan",
    "setupIntro": "Shift your sleep gradually toward a healthier schedule — a little earlier each step, held until your body adjusts.",
    "current": "Where you are now",
    "target": "Where you want to be",
    "bedtime": "Bedtime",
    "wake": "Wake-up",
    "shiftIncrement": "Shift per step",
    "holdDays": "Days per step",
    "melatoninOffset": "Melatonin before bed",
    "dose": "Melatonin dose",
    "minutes": "min",
    "days": "days",
    "hours": "hrs",
    "startPlan": "Start plan",
    "disclaimer": "General wellness guidance, not medical advice. Check with a doctor before taking melatonin.",
    "todayTargets": "Tonight's targets",
    "stepN": "Step {{n}}",
    "daysToTarget": "{{n}} days to target",
    "melatonin": "Melatonin",
    "doseHint": "Dose: {{dose}}",
    "morningLight": "Got morning light",
    "melatoninTaken": "Took melatonin",
    "windDownDone": "Did wind-down",
    "story": {
      "title": "Sleep story",
      "generate": "Write me one",
      "another": "Another one",
      "writing": "Writing…",
      "play": "Play",
      "pause": "Pause",
      "stop": "Stop",
      "failed": "Couldn't generate — try again.",
      "showText": "Show the text",
      "theme": {
        "calm": "Calm",
        "journey": "My journey",
        "reading": "My book"
      }
    },
    "logNight": "Log last night",
    "actualBedtime": "Actual bedtime",
    "actualWake": "Actual wake-up",
    "quality": "Sleep quality",
    "todayAdherence": "Adherence:",
    "streakN": "{{n}}-day streak",
    "maintenance": "Maintenance",
    "maintenanceTitle": "You've hit your target schedule",
    "taperHint": "Hold this rhythm. You can start tapering melatonin now — try halving the dose, then dropping it once your sleep stays steady.",
    "chartTitle": "Bedtime trend",
    "chartTarget": "Target {{time}}"
  },
  "habits": {
    "title": "Habits",
    "manage": "Manage habits",
    "empty": "No habits yet. Add one to start building a streak.",
    "add": "Add a habit",
    "editTitle": "Edit habit",
    "namePlaceholder": "e.g. Workout, Read, Pray…",
    "icon": "Icon",
    "color": "Color",
    "streakN": "{{n}}-day streak",
    "doneOfTotal": "{{done}}/{{total}} done",
    "manageHint": "Tap a habit to check it off for today."
  },
  "messages": {
    "list": {
      "title": "Messages",
      "startHint": "Tap to start chatting",
      "empty": "No conversations yet — add friends to start chatting."
    },
    "thread": {
      "empty": "No messages with {{name}} yet — say hi 👋",
      "placeholder": "Message…",
      "thinkingOfYou": "Thinking of you",
      "read": "Read",
      "sent": "Sent",
      "typing": "typing…",
      "online": "online",
      "actions": "Message actions",
      "edit": "Edit",
      "unsend": "Unsend",
      "deleted": "Message deleted",
      "edited": "edited",
      "reply": "Reply",
      "replyingTo": "Replying to {{name}}",
      "you": "You",
      "attachImage": "Send a photo",
      "viewOnceMode": "View-once photo mode",
      "tapToView": "Tap to view ({{n}}×)",
      "viewOnceSent": "View-once photo sent ({{n}}×)",
      "imageSeen": "Photo seen — no longer available",
      "notDelivered": "Notification not delivered",
      "notDeliveredRetry": "Notification didn't send — retry",
      "schedule": "Schedule send",
      "scheduleTitle": "Send later",
      "scheduleConfirm": "Schedule",
      "scheduled": "Scheduled",
      "recordVoice": "Record a voice note",
      "recording": "Recording…",
      "micDenied": "Mic access denied — enable it in your browser settings."
    },
    "detail": {
      "title": "Message",
      "from": "From {{name}}",
      "to": "To {{name}}",
      "openLink": "Open link"
    },
    "notFound": "Message not found.",
    "gallery": {
      "title": "Shared photos",
      "empty": "No photos shared yet."
    },
    "couple": {
      "title": "You two",
      "daysN": "{{n}} days together",
      "yourMood": "Your mood today",
      "anniversary": "Together since"
    },
    "gate": {
      "aria": "Unread message",
      "fromLine": "From {{name}}",
      "openInbox": "Open inbox",
      "close": "Got it",
      "moreCount": "{{count}} more waiting",
      "viewOncePhoto": "Sent a view-once photo — open the chat to see it"
    }
  },
  "briefing": {
    "play": "Morning briefing",
    "ready": "Briefing ready — tap to listen",
    "stop": "Stop briefing",
    "failed": "Briefing failed — tap to retry"
  },
  "wishlist": {
    "title": "Wishlist",
    "add": "Add",
    "empty": "Add things you're considering — the AI weighs them against your balance, surplus and targets.",
    "namePlaceholder": "What do you want to buy?",
    "pricePlaceholder": "Price (SAR)",
    "urlPlaceholder": "Link (optional)",
    "notesPlaceholder": "Notes…",
    "priority": { "1": "High", "2": "Mid", "3": "Low" },
    "advise": "Should I buy these now?",
    "verdict": { "now": "Buy it", "wait": "Wait", "skip": "Skip" },
    "bought": "Bought",
    "boughtList": "Bought ({{count}})",
    "open": "Open link",
    "confirm": "Sure?"
  },
  "rewrite": {
    "title": "Improve writing",
    "undo": "Undo rewrite",
    "style": {
      "improve": "Improve",
      "formal": "Formal",
      "casual": "Casual",
      "to_ar": "→ عربي",
      "to_en": "→ English"
    }
  },
  "fridge": {
    "title": "Recipes from your fridge",
    "snap": "Snap the fridge",
    "thinking": "Looking…",
    "hint": "Photograph your fridge — the AI reads what's there and suggests 3 meals that fit your targets and phase.",
    "failed": "Couldn't read that photo — try better lighting."
  },
  "people": {
    "title": "People",
    "add": "Add",
    "empty": "Add the few people who matter — birthdays, contact cadence, and you'll get nudged when someone goes quiet.",
    "namePlaceholder": "Name",
    "relationPlaceholder": "Relation… \"brother\", \"work friend\"",
    "birthday": "Birthday",
    "cadence": "Contact every (days)",
    "notesPlaceholder": "Notes — gifts, last conversation…",
    "contacted": "Contacted",
    "lastContact": "Last contact:",
    "quiet": "Quiet for {{count}} days past cadence",
    "birthdayToday": "Birthday today 🎂",
    "birthdayIn": "Birthday in {{count}} days",
    "confirm": "Sure?"
  },
  "onThisDay": {
    "title": "On this day",
    "yearsAgo": "{{count}} year(s) ago",
    "weight": "Your weight was {{weight}} kg",
    "moment": "A moment captured",
    "book": "You finished \"{{title}}\""
  },
  "goals": {
    "title": "Quarterly goals",
    "add": "Add",
    "empty": "Set 3–5 goals for this quarter — every Saturday the AI reviews where you actually are against them.",
    "titlePlaceholder": "The goal… \"reach 88kg\"",
    "metricPlaceholder": "How success is measured (optional)",
    "reviewTitle": "Weekly review",
    "reviewPending": "First AI review lands Saturday morning.",
    "markDone": "Mark done",
    "reopen": "Reopen",
    "confirm": "Sure?"
  },
  "lifeSearch": {
    "title": "Life Search",
    "placeholder": "Ask anything about your life…",
    "hint": "Searches across weight, meals, workouts, mood, health, finance, habits and more.",
    "ex1": "When did I last go to the dentist?",
    "ex2": "Which weeks did I work out more than 4 times?",
    "ex3": "How did my mood change last month?",
    "searching": "Searching your life…",
    "failed": "Search failed — try again.",
    "noData": "No matching data found for that window.",
    "sourcesLabel": "Sources:"
  },
  "quickCapture": {
    "button": "Capture anything",
    "title": "Quick Capture",
    "placeholder": "Type or speak anything… \"drank two glasses of water\", \"weight 92.5\", \"spent 40 on coffee\"",
    "submit": "Capture",
    "mic": "Dictate",
    "listening": "Listening…",
    "failed": "Couldn't process that — try again.",
    "savedTo": "Saved to {{module}} ✓",
    "inboxed": "Kept in inbox — {{module}}",
    "inboxTitle": "Inbox — past captures",
    "inboxEmpty": "Nothing in the inbox yet.",
    "multi": "Multiple",
    "modules": {
      "weight": "Weight",
      "water": "Water",
      "meal": "Meals",
      "mood": "Mood",
      "vital": "Vitals",
      "expense": "Expense",
      "note": "Note"
    }
  },
  "friends": {
    "title": "Friends",
    "myHandle": "Your handle",
    "handlePlaceholder": "username",
    "displayNamePlaceholder": "Display name",
    "handleHint": "3–20 characters: lowercase letters, numbers, underscore. Friends find you by this exact handle.",
    "handleTaken": "That username is taken.",
    "handleInvalid": "Invalid handle — 3–20 lowercase letters, numbers or _ only.",
    "handleSaved": "Saved ✓",
    "searchTitle": "Add a friend",
    "searchPlaceholder": "Friend's exact username",
    "suggestionsTitle": "Suggested for you",
    "mutualCount": "Mutual friends: {{count}}",
    "noMatch": "No user with that handle.",
    "add": "Send request",
    "requestSent": "Request sent ✓",
    "incoming": "Friend requests",
    "outgoing": "Sent requests",
    "accept": "Accept",
    "decline": "Decline",
    "cancel": "Cancel",
    "friendsList": "Your friends",
    "empty": "No friends yet — search a handle above to add one.",
    "message": "Message",
    "unfriend": "Unfriend",
    "block": "Block",
    "confirm": "Sure?",
    "blockedList": "Blocked",
    "unblock": "Unblock"
  },
  "moments": {
    "title": "Moments",
    "captureTitle": "Capture",
    "rules": "When Phoenix pings, both of you have 5 minutes to snap whatever you're doing — camera only, no gallery. Neither sees the other until both have submitted.",
    "streakLabel": "day streak",
    "noPromptToday": "No moment yet today. Phoenix will ping when it's time.",
    "openCamera": "Open camera",
    "windowClosingIn": "Closes in {{minutes}}m",
    "waitingForPartner": "Waiting for {{name}}…",
    "partnerMissed": "{{name}} missed this one",
    "youMissed": "You missed it. There's always tomorrow.",
    "revealed": "Revealed",
    "cameraDenied": "Camera access denied",
    "cameraDeniedHint": "Enable the camera in your browser settings to capture.",
    "cameraUnavailable": "Camera not available on this device.",
    "captureFailed": "Couldn't capture — try again.",
    "flipCamera": "Flip camera",
    "retry": "Try again",
    "shoot": "Capture",
    "back": "Back",
    "backToIndex": "Back to Moments",
    "you": "You",
    "lateBadge": "late",
    "notFound": "This moment is no longer available.",
    "historyComingSoon": "Past moments — coming soon",
    "browseHistory": "Browse past moments",
    "archiveTitle": "Past moments",
    "archiveEmpty": "No moments yet — your first one's coming.",
    "archiveMissed": "missed",
    "archiveSolo": "solo",
    "reactWith": "React with {{emoji}}",
    "commentPlaceholder": "Say something…",
    "sendComment": "Send comment",
    "digestNotFound": "No recap for this month yet.",
    "digestEmpty": "Quiet month — nothing to recap.",
    "digestStats": {
      "moments": "moments",
      "longestStreak": "longest streak",
      "totalDays": "days tracked"
    }
  },
  "reading": {
    "title": "Reading",
    "addBook": "Add book",
    "addBookTitle": "Add a book",
    "addHighlight": "Add",
    "back": "Back",
    "delete": "Delete",
    "deleteHighlight": "Delete highlight",
    "save": "Save",
    "confirmDelete": "Delete this book and all its highlights?",
    "notFound": "Book not found.",
    "emptyShelf": "Nothing on this shelf yet.",
    "notesLabel": "Notes",
    "notesPlaceholder": "Anything you want to remember about this book…",
    "highlightsLabel": "Highlights",
    "highlightPlaceholder": "Pull a line from the book…",
    "pageNumber": "Page",
    "page": "p. {{n}}",
    "fromShelf": "From {{name}}'s shelf",
    "startedOn": "Started {{date}}",
    "finishedOn": "Finished {{date}}",
    "status": {
      "wishlist": "Wishlist",
      "reading": "Reading",
      "finished": "Finished",
      "paused": "Paused"
    },
    "fields": {
      "title": "Title",
      "author": "Author",
      "status": "Status",
      "coverUrl": "Cover URL",
      "coverUrlHint": "Optional — paste a link to the cover image."
    },
    "file": {
      "label": "Book file",
      "pick": "Choose a PDF or EPUB",
      "attach": "Attach a file",
      "reattach": "Re-attach the file",
      "replace": "Replace file",
      "remove": "Remove file",
      "open": "Open",
      "start": "Start reading",
      "continue": "Continue · {{n}}%",
      "missing": "This book's file is on another device — re-attach it here to read on this one.",
      "localOnly": "Stored on this device only.",
      "localOnlyHint": "PDF or EPUB — kept on this device only, not synced.",
      "pickError": "Only PDF or EPUB files are supported.",
      "pdf": "PDF",
      "epub": "EPUB"
    },
    "progress": {
      "read": "{{n}}% read",
      "lastRead": "Last read {{date}}"
    },
    "finishCta": "I finished this book",
    "changeStatus": "Change status",
    "aiSynthesisLabel": "Synthesis",
    "aiSynthesisPending": "Writing your synthesis…",
    "recapNotFound": "No recap for this quarter yet.",
    "recapEmpty": "Quiet quarter — no books finished.",
    "recapBookCount": "books finished",
    "recapPending": "Recap pending…",
    "browseCatalog": "Browse",
    "catalogTitle": "Free books",
    "catalogEmpty": "Nothing found — try another search.",
    "searchPlaceholder": "Search by title or author…",
    "searchGo": "Search",
    "loadMore": "Load more",
    "addToShelf": "Add to shelf",
    "sources": {
      "archive": "Arabic (Internet Archive)",
      "gutenberg": "English (Gutenberg)"
    },
    "categories": {
      "recommended": "Recommended",
      "novels": "Novels",
      "islamic": "Islamic",
      "history": "History",
      "philosophy": "Philosophy",
      "poetry": "Poetry",
      "romance": "Romance",
      "adventure": "Adventure",
      "mystery": "Mystery",
      "sciencefiction": "Science fiction"
    },
    "seeAll": "See all",
    "clearSearch": "Clear",
    "readBook": "Read",
    "readerSettings": "Reader settings",
    "readerLoadFailed": "Couldn't load the text.",
    "readerEmpty": "This book is empty.",
    "fontSize": "Font size",
    "fontDecrease": "Smaller",
    "fontIncrease": "Larger",
    "markFinished": "Mark as finished",
    "saveSpot": "Save my spot",
    "addSelectionHighlight": "Add as highlight",
    "previousPage": "Previous page",
    "nextPage": "Next page"
  },
  "games": {
    "title": "Games",
    "spy": {
      "title": "Spy",
      "tabLabel": "Spy",
      "players": "Players",
      "playerPlaceholder": "Player {{n}}",
      "addPlayer": "Add player",
      "removePlayer": "Remove player",
      "computerPlayers": "Bots",
      "addBot": "Add a computer player",
      "removeBot": "Remove a computer player",
      "botName": "Computer {{n}}",
      "interrogate": "Question the computer",
      "discussion": "Discussion",
      "askNow": "Ask now",
      "feedHint": "Bots ask on their own — answer out loud, or reply here.",
      "replyPlaceholder": "Reply to the computer…",
      "nextQuestion": "Next question",
      "replyToTarget": "Reply to {{name}}…",
      "askPlaceholder": "Ask something… (or just tap send)",
      "botAsk": "Let the computer ask a question",
      "botFailed": "…(no answer — try again)",
      "modeLocal": "One phone",
      "modeOnline": "Online room",
      "yourName": "Your name",
      "createRoom": "Create a room",
      "joinRoom": "Join a room",
      "codePlaceholder": "CODE",
      "roomNotFound": "No room with that code.",
      "roomInProgress": "That game already started.",
      "roomCode": "Room code",
      "shareCode": "Share this code so others can join.",
      "inviteFriends": "Invite friends",
      "invite": "Invite",
      "invited": "Sent ✓",
      "host": "Host",
      "waitingHost": "Waiting for the host to start…",
      "voteWho": "Who's the spy?",
      "computerTurn": "Computer's turn to ask",
      "votes": "Votes",
      "leaveRoom": "Leave room",
      "roundTime": "Round time",
      "minutes": "{{n}} min",
      "start": "Start the round",
      "needMore": "Add at least {{n}} players to start.",
      "passTo": "Pass the phone to {{name}}",
      "tapToReveal": "Tap to see your card",
      "youAreSpy": "You're the spy 🕵️",
      "spyHint": "Blend in and figure out the location.",
      "theLocation": "The location",
      "yourRole": "Your role: {{role}}",
      "hideAndPass": "Hide & pass on",
      "startRound": "Everyone's ready — start",
      "discussHint": "Ask each other questions. Find the spy before time runs out.",
      "timeUp": "Time's up! Vote for the spy.",
      "pause": "Pause",
      "resume": "Resume",
      "addMinute": "+1 min",
      "reveal": "Reveal the spy",
      "theSpy": "The spy was",
      "theSpies": "The spies were",
      "playAgain": "Play again",
      "newSetup": "New setup",
      "howToTitle": "How to play Spy",
      "how1": "Add 3–8 players and pass the one phone around.",
      "how2": "Everyone gets the same secret location — except one or two spies who get nothing.",
      "how3": "Take turns asking subtle questions about the place. Don't be too obvious, or the spy will catch on.",
      "how4": "Before time's up, vote on who the spy is. The spy wins if they guess the location or slip away.",
      "gotIt": "Got it",
      "whoWon": "Who won this round?",
      "outcomeCaught": "We caught the spy",
      "outcomeGuessed": "The spy guessed the location",
      "outcomeEscaped": "The spy slipped away",
      "skipLog": "Skip — don't log this round",
      "logged": "Round logged",
      "scoreboard": "Scoreboard",
      "noResults": "No rounds logged yet.",
      "bestBluffer": "Best bluffer",
      "mostCaught": "Caught most",
      "spyWinsN": "{{n}} spy wins",
      "caughtN": "caught {{n}}×",
      "colPlayer": "Player",
      "colGames": "Games",
      "colSpyWins": "Spy wins",
      "colCaught": "Caught"
    },
    "quiz": {
      "title": "Quiz",
      "tabLabel": "Quiz",
      "howToPlay": "How the Quiz works",
      "runningTally": "Your guesses about your partner, all-time",
      "you": "You",
      "soloUnavailable": "Quiz needs two players — invite your partner first.",
      "startBlurb": "Pick 5 questions you both know each other on. How many can you guess about {{name}}?",
      "startCta": "Start a new round",
      "deckLabel": "Deck: {{name}}",
      "deck": {
        "preferences": { "name": "Tastes", "blurb": "Food, weather, daily choices" },
        "dreams":      { "name": "Dreams", "blurb": "Future, home, the long view" },
        "goofy":       { "name": "Goofy",  "blurb": "Pizza, snacks, silly picks" },
        "memories":    { "name": "Memory", "blurb": "Childhood, last trips, gifts" },
        "spicy":       { "name": "Romance","blurb": "Love language, dates, warm questions" },
        "deep":        { "name": "Deep",   "blurb": "Beliefs, values, the big love questions" },
        "intimate":    { "name": "Intimate", "blurb": "The 36 questions to fall in love — adapted to choices" },
        "surprise":    { "name": "Surprise me", "blurb": "Random pull from every deck" }
      },
      "questionN": "Question {{n}} of {{total}}",
      "yourAnswer": "Your answer",
      "guessTheirs": "What would they pick?",
      "submitNext": "Submit & next",
      "submitFinal": "Submit & finish round",
      "submitting": "Saving…",
      "submitFailed": "Couldn't save — check your connection and try again.",
      "abandonRound": "Abandon this round and pick a new deck",
      "list": {
        "empty": "No rounds in flight. Start one and {{name}} will pick it up — or refresh if you're expecting one.",
        "refresh": "Refresh",
        "startNew": "Start a new round",
        "history": "View completed quizzes",
        "cardMyTurn": "Your turn — {{progress}}/{{total}} answered",
        "cardWaiting": "Waiting on {{name}} — they're at {{progress}}/{{total}}",
        "cardAbandon": "Skip this one",
        "backToRounds": "Back to rounds",
        "abandonConfirmTitle": "Skip this round?",
        "abandonConfirmBody": "{{name}} won't see this round anymore. You can undo right after.",
        "abandonConfirmYes": "Yes, skip",
        "abandonConfirmCancel": "Keep it",
        "undoToast": "Round skipped.",
        "undoCta": "Undo"
      },
      "history": {
        "title": "Completed quizzes",
        "empty": "No completed rounds yet — finish one together and it'll land here."
      },
      "waitingOnPartner": "{{name}} is still answering — results show once you're both done.",
      "bothDone": "Round complete — here's how you did",
      "knewAbout": "Guesses about {{name}}",
      "guessedThem": "You guessed they'd pick {{choice}}",
      "startAnother": "Play another round",
      "playAnotherWhileWait": "Play another while you wait",
      "waitingPanelOne": "{{name}} hasn't finished this round yet. You can wait, or start another.",
      "waitingPanelMany": "{{count}} rounds waiting on {{name}} to finish.",
      "partnerProgressLine": "{{name}} on {{progress}} of {{total}}",
      "skipOne": "Skip",
      "inFlightChip": "{{count}} waiting on {{name}}",
      "revealBanner": "Round ready — tap to see results",
      "revealBannerMany": "{{count}} rounds ready — tap to see results",
      "howTo": {
        "line1": "Each round is 5 questions. Both of you answer the same five.",
        "line2": "For each question you tap two things: what you'd pick, and what you think they'd pick.",
        "line3": "Results show once both of you finish — including how many you guessed right about each other.",
        "line4": "Your all-time accuracy lives in the trophy chip at the top.",
        "cta": "Got it"
      }
    },
    "questions": {
      "title": "Daily Question",
      "tabLabel": "Questions",
      "howToPlay": "How it works",
      "streakLabel": "Days you both answered",
      "you": "You",
      "reveal": "Today's answers",
      "partnerNotStarted": "{{name}} hasn't answered yet",
      "partnerNotYet": "Waiting on {{name}}…",
      "partnerAnsweredWaiting": "{{name}} answered — your turn",
      "howTo": {
        "line1": "One question every day, same one for both of you.",
        "line2": "Tap your answer. You can't change it — pick the one that feels true.",
        "line3": "Your partner's choice stays hidden until you've both picked.",
        "line4": "A new question shows up at midnight, same for both of you.",
        "cta": "Got it"
      },
      "suggest": {
        "cta": "Suggest a question ({{count}} in the pool)",
        "title": "Suggest a question",
        "category": "Category",
        "questionEn": "Question (English)",
        "questionEnPh": "What's your favourite snack?",
        "questionAr": "Question (Arabic)",
        "questionArPh": "إيه السناك المفضل؟",
        "options": "Options (3-5, both languages)",
        "addOption": "Add another option",
        "removeOption": "Remove option",
        "submit": "Add to the pool",
        "submitting": "Saving…",
        "submitFailed": "Couldn't save — check your connection and try again."
      }
    },
    "wordle": {
      "title": "Wordle",
      "tabLabel": "Wordle",
      "streakLabel": "Day streak",
      "modeDaily": "Daily",
      "modePractice": "Practice",
      "modePracticeNext": "New word",
      "practiceMode": "Practice mode — doesn't count toward streak",
      "practiceHint": "Practice rounds don't save or break your streak.",
      "playAgain": "Play again",
      "share": "Share",
      "copied": "Copied to clipboard",
      "copyFailed": "Couldn't copy — long-press to copy manually.",
      "notEnough": "Not enough letters",
      "notInList": "Not in word list",
      "youWon_one": "Solved in {{count}} guess.",
      "youWon_other": "Solved in {{count}} guesses.",
      "youLost": "Better luck tomorrow. The word was {{answer}}.",
      "lostAnswer": "The word was {{answer}}.",
      "shareTitleDaily": "Phoenix Wordle {{date}} {{score}}",
      "shareTitlePractice": "Phoenix Wordle Practice {{score}}",
      "howToPlay": "How to play",
      "win": {
        "1": "Genius",
        "2": "Magnificent",
        "3": "Impressive",
        "4": "Splendid",
        "5": "Great",
        "6": "Phew"
      },
      "howTo": {
        "line1": "Guess the 5-letter word in 6 tries.",
        "line2": "Each guess must be a real word — hit Enter to submit.",
        "green": "Letter is in the word and in the right spot.",
        "yellow": "Letter is in the word but in the wrong spot.",
        "gray": "Letter is not in the word.",
        "daily": "A new daily word at midnight — same word for both of you.",
        "cta": "Got it"
      },
      "partner": {
        "you": "You",
        "jointStreak_one": "{{count}} day together",
        "jointStreak_other": "{{count}} days together",
        "not_started": "{{name}} hasn't started yet",
        "playing": "{{name}} is playing now…",
        "won": "{{name}} finished — count revealed when you're done too",
        "lost": "{{name}} didn't get it today"
      },
      "scoreboard": {
        "title": "Today's results"
      }
    }
  },
  "footer": {
    "madeWith": "Made with",
    "by": "by",
    "allRights": "All rights reserved."
  },
  "hairRoutine": {
    "title": "Hair Routine",
    "subtitle": "Your weekly hair care schedule and product guide",
    "weeklyRoutine": "Weekly Routine",
    "schedule": "Schedule",
    "weeklyRoutineDesc": "Your hair care routine organized by day of the week",
    "productUsageGuide": "Product Usage Guide",
    "products": "Products",
    "productUsageDesc": "Detailed instructions for each product in your hair care routine",
    "proTips": "💡 Pro Tips",
    "proTipsDesc": "Remember these key points for optimal hair care",
    "tips": [
      "Always use mineral water for the final rinse after conditioner",
      "Apply Seven Minerals oil sparingly - 2-3 drops is sufficient",
      "Use Cantu Leave-In daily for moisture and protection",
      "Elvive Hair Oil is perfect for styling and shine on dry hair"
    ],
    "table": {
      "day": "Day",
      "steps": "Steps"
    },
    "routine": [
      {"day": "Saturday", "steps": "Shampoo + Conditioner, then Seven Minerals oil on scalp + Cantu cream on hair"},
      {"day": "Tuesday", "steps": "Conditioner only + rinse with mineral water, optionally use Elvive or Cantu"},
      {"day": "Thursday", "steps": "Shampoo + Conditioner, then Seven Minerals on scalp + Cantu on ends"},
      {"day": "Other Days", "steps": "Use Cantu or Elvive as needed, no washing"}
    ],
    "productTable": {
      "product": "Product",
      "instructions": "Instructions"
    },
    "productsList": [
      {"product": "L'Oréal Ever Pure Shampoo", "instructions": "Use twice a week on scalp and hair, then rinse"},
      {"product": "L'Oréal Ever Pure Conditioner", "instructions": "Apply after shampoo, leave 2–3 mins, rinse with regular water, then final rinse with mineral water"},
      {"product": "Cantu Leave-In", "instructions": "Use daily after mineral water rinse or shower, small amount on damp or dry hair"},
      {"product": "Seven Minerals Oil", "instructions": "2–3 drops on scalp twice a week, massage gently. Optional: 1 drop on ends for shine"},
      {"product": "Elvive Hair Oil", "instructions": "Use before going out or for light styling on dry hair ends"}
    ]
  },
  "skinRoutine": {
    "title": "Skin Routine",
    "subtitle": "Your skincare routine and product guide",
    "comingSoon": "Coming Soon!",
    "comingSoonDesc": "Your skin routine content will be defined here later",
    "underDevelopment": "🚧 Under Development",
    "dailyRoutine": "Daily Routine",
    "dailyRoutineDesc": "Morning and evening skincare steps",
    "productGuide": "Product Guide",
    "productGuideDesc": "Your skincare products and usage instructions",
    "placeholder": "Content will be added here..."
  },
  "nutritionPlan": {
    "title": "Week 1 – Metabolic Recovery Plan",
    "subtitle": "A 7-day rebalancing nutrition plan to restore metabolism and energy balance",
    "overview": "Overview",
    "overviewText": "This 7-day metabolic recovery plan helps reset the body's metabolism and stabilize energy levels after a period of inconsistent eating habits. It focuses on simple, balanced meals with natural ingredients, moderate portions, and no junk food or nuts.",
    "dailyCalorieRange": "Daily Calorie Range",
    "dailyCalorieDesc": "Maintenance calories for metabolic recovery",
    "total": "Total",
    "maintenance": "maintenance for the first week",
    "macros": "Macros",
    "protein": "Protein",
    "carbs": "Carbs",
    "fats": "Fats",
    "keyRules": "Key Rules",
    "keyRulesDesc": "Essential guidelines for this plan",
    "rule1": "Eat",
    "rule1Meals": "2–3 small main meals",
    "rule1And": "and",
    "rule1Snack": "1 light snack",
    "rule1Daily": "daily.",
    "rule2": "Drink",
    "rule2Water": "2.5–3L of water",
    "rule2PerDay": "per day.",
    "rule3": "Avoid skipping meals, even if not hungry.",
    "rule4": "No nuts, chips, flavored seeds, chocolate milk, or soft drinks.",
    "rule5": "Limit juices to",
    "rule5Times": "1–2 times per week",
    "rule5End": ".",
    "rule6": "Coffee and tea without sugar are allowed (Stevia optional).",
    "breakfastOptions": "Breakfast Options",
    "breakfastDesc": "Choose one daily",
    "option": "Option",
    "tip": "Tip",
    "breakfastOption1": "White cheese sandwich + coffee/tea + one fruit (banana or apple)",
    "breakfastOption2": "2 boiled eggs + whole wheat toast + cucumber & tomato",
    "breakfastOption3": "Oatmeal with low-fat milk + 1 tsp honey (optional)",
    "breakfastTip": "If not hungry in the morning, have at least fruit + coffee to stimulate metabolism.",
    "lunchOptions": "Lunch Options",
    "protein": "Protein",
    "proteinDesc": "200g choose one",
    "protein1": "Grilled chicken breast",
    "protein2": "Grilled minced beef (kofta)",
    "protein3": "Grilled or baked fish / tuna (drained)",
    "carbs": "Carbs",
    "carbsDesc": "choose one",
    "carbs1": "½ cup cooked rice",
    "carbs2": "1 small whole-wheat loaf",
    "carbs3": "1 medium boiled or baked potato",
    "vegetables": "Vegetables",
    "vegetablesDesc": "mandatory",
    "vegetables1": "Large salad with olive oil dressing",
    "vegetables2": "Or steamed veggies (carrot, zucchini, pepper)",
    "optional": "Optional",
    "optionalDesc": "1–2 times/week",
    "optional1": "1 cup of natural juice or regular milk (no chocolate)",
    "dinnerOptions": "Dinner Options",
    "dinnerSubtitle": "Light",
    "dinner1": "Low-fat yogurt + 2 dates",
    "dinner2": "1 boiled egg + cucumber",
    "dinner3": "1 cup milk + 1 small toast with light cheese",
    "dinnerTip": "Skip dinner only if not hungry at all; otherwise, choose a light option.",
    "snackOptions": "Snack Options",
    "snackDesc": "Once per day only",
    "snack1": "1 fruit (apple, orange, banana)",
    "snack2": "OR 3 small dates",
    "snack3": "OR 1 healthy oatmeal biscuit",
    "hydration": "Hydration",
    "hydrationText": "Drink",
    "hydrationWater": "2.5–3 liters of water",
    "hydrationDaily": "daily.",
    "hydrationTip": "1 cup before every meal is recommended.",
    "weekSchedule": "Example Week Schedule",
    "weekScheduleDesc": "Daily meal breakdown for the week",
    "planBadge": "7-Day Plan",
    "table": {
      "day": "Day",
      "breakfast": "Breakfast",
      "lunch": "Lunch",
      "dinner": "Dinner",
      "snack": "Snack"
    },
    "schedule": [
      {"day": "Monday", "breakfast": "Option 1", "lunch": "Chicken + rice + salad", "dinner": "Yogurt + 2 dates", "snack": "Apple"},
      {"day": "Tuesday", "breakfast": "Option 2", "lunch": "Kofta + bread + veggies", "dinner": "Boiled egg + cucumber", "snack": "3 dates"},
      {"day": "Wednesday", "breakfast": "Option 3", "lunch": "Fish + potato + salad", "dinner": "Milk + toast + cheese", "snack": "Orange"},
      {"day": "Thursday", "breakfast": "Option 1", "lunch": "Chicken + rice + salad", "dinner": "Yogurt + 2 dates", "snack": "Oatmeal biscuit"},
      {"day": "Friday", "breakfast": "Option 2", "lunch": "Kofta + bread + salad", "dinner": "Boiled egg + cucumber", "snack": "Banana"},
      {"day": "Saturday", "breakfast": "Option 3", "lunch": "Fish + potato + salad", "dinner": "Milk + toast + cheese", "snack": "Apple"},
      {"day": "Sunday", "breakfast": "Option 1", "lunch": "Chicken + rice + salad", "dinner": "Yogurt + 2 dates", "snack": "Orange"}
    ],
    "notes": "Notes",
    "note1": "Goal: Restore normal metabolism before starting a calorie deficit.",
    "note2": "Focus on consistency and hydration, not rapid weight loss.",
    "note3": "Begin gym training with light full-body workouts",
    "note3Times": "3–4 times per week",
    "note3End": ".",
    "note4": "Weigh only twice: start and end of the week.",
    "note5": "After this phase, a gradual fat-loss plan can begin safely.",
    "phase2": "Phase 2 (Next Steps)",
    "phase2Desc": "What comes after the Week 1 Metabolic Recovery Plan",
    "phase2Intro": "After completing the Week 1 Metabolic Recovery Plan:",
    "phase2Step1": "Evaluate how your body feels — check energy, sleep, and appetite.",
    "phase2Step2": "If energy is stable and digestion feels normal, move to",
    "phase2Step2Bold": "Phase 2: Gradual Fat Loss",
    "phase2Step2End": ".",
    "phase2Step3": "In Phase 2, total calories will decrease by",
    "phase2Step3Bold": "300–400 kcal daily",
    "phase2Step3End": ", while keeping meals balanced.",
    "phase2Step4": "Include",
    "phase2Step4Bold1": "4 days of resistance training",
    "phase2Step4And": "and",
    "phase2Step4Bold2": "1–2 light cardio sessions",
    "phase2Step4End": "weekly.",
    "phase2Step5": "Add one",
    "phase2Step5Bold": "\"refeed day\"",
    "phase2Step5End": "every 7–10 days to maintain metabolic health.",
    "phase2Step6": "Focus on sustainability, not perfection —",
    "phase2Step6Bold": "consistency matters most",
    "phase2Step6End": "."
  },
  "phoenixTracker": {
    "title": "Phoenix Tracker",
    "subtitle": "Track your body transformation journey",
    "units": {
      "metric": "Metric",
      "imperial": "Imperial",
      "kg": "kg",
      "lb": "lb",
      "cm": "cm",
      "in": "in",
      "switchTo": "Switch to {{system}}"
    },
    "tabs": {
      "today": "Today",
      "weight": "Weight",
      "water": "Water",
      "meals": "Meals",
      "measurements": "Measurements",
      "workouts": "Workouts",
      "photos": "Photos",
      "news": "News",
      "social": "Social",
      "progress": "Progress",
      "profile": "Profile"
    },
    "today": {
      "greetingNamed": "Hey {{name}} 👋",
      "greetingPlain": "Hey 👋",
      "weight": "Weight",
      "meals": "Meals",
      "workout": "Workout",
      "moodTitle": "How are you feeling today?",
      "energyTitle": "And how's your energy?",
      "mood": "Mood",
      "energy": "Energy",
      "moodWord1": "Awful",
      "moodWord2": "Meh",
      "moodWord3": "Okay",
      "moodWord4": "Good",
      "moodWord5": "Great",
      "energyWord1": "Drained",
      "energyWord2": "Low",
      "energyWord3": "Okay",
      "energyWord4": "High",
      "energyWord5": "Charged",
      "couplesTitle": "You + {{name}}",
      "dailyQuestion": "Daily question",
      "qState": {
        "neither": "Pick today's question",
        "iAnsweredWaiting": "Done — waiting on {{name}}",
        "partnerAnsweredYourTurn": "{{name}} answered — your turn",
        "bothDone": "Both done — see the reveal"
      },
      "wordle": "Wordle",
      "wordleState": {
        "neither": "Today's word is waiting",
        "iPlaying": "You're mid-game",
        "iPlayingPartnerDone": "You're mid-game · {{name}} finished",
        "bothPlaying": "Both of you are mid-game",
        "partnerPlaying": "{{name}} started — your turn",
        "partnerDoneYourTurn": "{{name}} finished — your turn",
        "iDoneWaiting": "You finished — waiting on {{name}}",
        "iDonePartnerPlaying": "You finished · {{name}} still playing",
        "bothFinished": "Both done — share your grids"
      },
      "quiz": "Quiz",
      "quizState": {
        "fresh": "Start a new round",
        "myTurn": "Round waiting on you",
        "waiting": "Waiting on {{name}}",
        "revealReady": "Reveal ready — see the score"
      },
      "moments": "Moments",
      "momentsState": {
        "noPromptYet": "Waiting for today's ping",
        "openNeither": "Camera's open — capture now",
        "iSubmittedWaiting": "Snapped — waiting for {{name}}",
        "partnerSubmittedYourTurn": "{{name}} snapped — your turn",
        "bothRevealed": "Both in — reveal ready",
        "bothMissed": "You both missed it",
        "partnerMissedMine": "{{name}} missed it",
        "iMissedPartner": "You missed it"
      },
      "currentWeight": "Current weight",
      "headline": "Top headline",
      "more": "More"
    },
    "weight": {
      "date": "Date",
      "weight": "Weight (kg)",
      "add": "Add",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "confirmDelete": "Delete this entry?",
      "confirmDeleteDesc": "This will permanently remove this weight entry.",
      "noEntries": "No weight entries yet. Start tracking!",
      "showMore": "Show more",
      "showLess": "Show less",
      "trend": "Weight Trend",
      "kg": "kg",
      "gained": "gained",
      "lost": "lost",
      "note": "Note",
      "notePlaceholder": "Add note (optional)",
      "movingAverage": "Moving Avg",
      "windows": {
        "day": "d",
        "off": "Off"
      },
      "legendDailyLabel": "Daily weight",
      "legendDailyDesc": "your actual scale reading each day",
      "legendAvgLabel": "{{window}}-day average",
      "legendAvgDesc": "smoothed trend — lags the current value when weight is moving fast",
      "dateToday": "Today",
      "dateYesterday": "Yesterday",
      "addNote": "Add note",
      "logWeight": "Log weight",
      "weightPlaceholder": "0.0",
      "tapToEnter": "Tap to enter your weight",
      "trendOverDays": "{{delta}} {{unit}} over {{n}}d"
    },
    "measurements": {
      "date": "Date",
      "neck": "Neck",
      "chest": "Chest",
      "belly": "Belly",
      "waist": "Waist",
      "arm": "Arm",
      "thigh": "Thigh",
      "add": "Add Measurement",
      "delete": "Delete",
      "confirmDelete": "Delete this measurement?",
      "confirmDeleteDesc": "This will permanently remove this measurement set.",
      "noEntries": "No measurements yet. Start tracking!",
      "cm": "cm",
      "note": "Note",
      "notePlaceholder": "Add note (optional)",
      "trend": "Measurement Trend",
      "selectMetric": "Select metric",
      "bodyFat": "Body Fat"
    },
    "progress": {
      "title": "Progress Dashboard",
      "startWeight": "Start Weight",
      "goalWeight": "Goal Weight",
      "currentWeight": "Current Weight",
      "totalLost": "Total Lost",
      "remaining": "Remaining",
      "avgLossRate": "7-Day Avg Loss",
      "lowestWeight": "Lowest",
      "highestWeight": "Highest",
      "totalEntries": "Total Entries",
      "currentStreak": "Current Streak",
      "longestStreak": "Longest Streak",
      "days": "days",
      "bmi": "BMI",
      "bodyFat": "Body Fat",
      "category": {
        "underweight": "Underweight",
        "normal": "Normal",
        "overweight": "Overweight",
        "obese": "Obese"
      },
      "pace": {
        "ahead": "Ahead of pace by {{delta}} {{unit}}/week",
        "on": "On pace 🎯",
        "behind": "Behind pace by {{delta}} {{unit}}/week"
      },
      "incompleteGoals": "Set your goals to see progress stats",
      "completeGoalsCta": "Set goals",
      "setHeight": "Set Your Height",
      "setHeightDesc": "Enter your height to enable BMI tracking",
      "height": "Height",
      "cm": "cm",
      "saveHeight": "Set Height",
      "activity": "Activity",
      "daysLogged": "{{count}} of {{total}} days logged",
      "noEntry": "No entry",
      "milestones": {
        "title": "Milestones",
        "reached": "Reached {{date}}",
        "toGo": "{{value}} {{unit}} to go",
        "goal": "Goal",
        "allReached": "All milestones reached!"
      },
      "weekShort": "wk",
      "progressBar": "Progress",
      "noData": "Add weight entries to see your progress",
      "completed": "completed",
      "perWeek": "kg/week",
      "summary": {
        "week": { "title": "This week" },
        "month": { "title": "This month" },
        "weightLost": "Down {{delta}} {{unit}}",
        "weightGained": "Up {{delta}} {{unit}}",
        "weightNoChange": "No weight change",
        "bestDay": "Best day: {{day}} — lost {{delta}} {{unit}}",
        "water": "Water avg {{avg}} L/day · hit goal {{hit}}/{{of}} days",
        "workouts": "{{count}} sessions · {{volume}} kg volume",
        "workoutsWithCardio": "{{count}} sessions · {{volume}} kg volume · {{cardio}} min cardio",
        "mealsAvg": "Avg {{avgKcal}} kcal/day · {{entries}} meals"
      }
    },
    "meals": {
      "title": "Meals",
      "subtitle": "Track calories and macros.",
      "today": "Today",
      "addCta": "Add meal",
      "addForType": "+ Add {{type}}",
      "empty": "No meals logged for this day yet.",
      "kcalUnit": "kcal",
      "dailyTotal": "Daily total",
      "search": {
        "label": "Search food database",
        "placeholder": "Search Open Food Facts (oatmeal, chicken…)",
        "noResults": "No matches. Try a different word, or fill the fields manually.",
        "attribution": "Per 100g · Powered by Open Food Facts (CC-BY-SA)"
      },
      "types": {
        "breakfast": "Breakfast",
        "lunch": "Lunch",
        "dinner": "Dinner",
        "snack": "Snack"
      },
      "macrosShort": "{{protein}}P / {{carbs}}C / {{fat}}F",
      "treatBadge": "Occasional",
      "form": {
        "title": "Log a meal",
        "editTitle": "Edit meal",
        "type": "Meal type",
        "name": "Name",
        "namePlaceholder": "Oatmeal, chicken bowl…",
        "portion": "Portion (g)",
        "myFoods": "My foods",
        "recent": "Recent",
        "kcal": "Calories",
        "macrosToggle": "Macros (optional)",
        "protein": "Protein (g)",
        "carbs": "Carbs (g)",
        "fat": "Fat (g)",
        "notes": "Notes",
        "notesPlaceholder": "Anything worth remembering…",
        "save": "Save meal",
        "saving": "Saving…",
        "cancel": "Cancel",
        "errorName": "Name is required.",
        "errorKcal": "Calories must be 0 or more."
      },
      "confirmDelete": "Delete this meal?",
      "confirmDeleteDesc": "This meal entry will be removed.",
      "delete": "Delete meal",
      "targets": {
        "title": "Today's progress",
        "edit": "Edit targets",
        "set": "Set targets",
        "noTargets": "Set daily calorie and macro targets to see progress rings here.",
        "suggestedTitle": "Apply daily targets from your plan",
        "suggestedApply": "Apply",
        "form": {
          "kcal": "Daily calories",
          "protein": "Protein (g)",
          "carbs": "Carbs (g)",
          "fat": "Fat (g)",
          "save": "Save targets",
          "clear": "Clear all targets"
        }
      },
      "rings": {
        "kcal": "Calories",
        "protein": "Protein",
        "carbs": "Carbs",
        "fat": "Fat"
      },
      "builder": {
        "heading": "Pick what you ate",
        "suggestedHeading": "Suggested for {{slot}}",
        "otherFoodsHeading": "Other foods",
        "noFoods": "No foods yet. Add a custom food.",
        "searchPlaceholder": "Search foods…",
        "clearSearch": "Clear search",
        "noSearchResults": "No foods match \"{{query}}\".",
        "recipeIngredients": "Ingredients",
        "addCustom": "Add custom food",
        "totalLabel": "Total",
        "itemsCount_one": "{{count}} item",
        "itemsCount_other": "{{count}} items"
      },
      "slot": {
        "tapToLog": "Tap to log {{slot}}",
        "addAnother": "Add another"
      }
    },
    "analysis": {
      "sectionTitle": "Analysis",
      "rangeAria": "Analysis time range",
      "range": {
        "phase": "Phase"
      },
      "insights": {
        "title": "Insights",
        "empty": "Not enough data yet — log a few more days to see insights.",
        "weeklyChangeLosing": "You're losing about <0>{{rate}} kg/week</0> over this range.",
        "weeklyChangeGaining": "You're gaining about <0>{{rate}} kg/week</0> over this range.",
        "kcalAvg": "Average daily intake is <0>{{avg}} kcal</0> — {{delta}} vs your <0>{{target}}</0> target.",
        "trainingRestKcal": "Training days run <0>{{delta}} kcal</0> vs rest days.",
        "kcalBurnedAvg": "You burn about <0>{{burn}} kcal</0> per training day.",
        "mealStreak": "Best meal-logging streak in your history: <0>{{streak}} days</0>.",
        "lowProtein": "Protein target hit <0>{{pct}}%</0> of days — worth pushing higher.",
        "highProtein": "Protein target hit <0>{{pct}}%</0> of days — strong adherence."
      },
      "weightCalories": {
        "title": "Weight × Calories",
        "weight": "Weight",
        "kcal": "Calories in",
        "kcalBurned": "Calories out",
        "empty": "No weight or meal data in this range."
      },
      "adherence": {
        "title": "Macro adherence",
        "subtitle": "Days hitting target within ±10% — based on {{days}} of {{total}} days logged.",
        "noTargets": "Set daily targets in the Meals tab to see adherence here.",
        "kcal": "Calories",
        "protein": "Protein",
        "carbs": "Carbs",
        "fat": "Fat"
      },
      "matrix": {
        "title": "Training vs rest",
        "training": "Training",
        "rest": "Rest",
        "daysShort": "days",
        "empty": "Log workouts and meals to compare training vs rest days.",
        "kcal": "Avg calories",
        "protein": "Avg protein (g)",
        "carbs": "Avg carbs (g)",
        "fat": "Avg fat (g)",
        "kcalBurned": "Avg kcal burned"
      },
      "streaks": {
        "title": "Logging streaks",
        "weight": "Weight",
        "meals": "Meals",
        "water": "Water",
        "best": "best {{n}}"
      }
    },
    "phases": {
      "title": "Phases",
      "subtitle": "Track segments of your transformation.",
      "manageLink": "Manage phases",
      "currentTitle": "Current phase",
      "noCurrent": "No active phase",
      "addCta": "New phase",
      "empty": "No phases yet. Define your first to track a focused segment of your transformation.",
      "type": {
        "cut": "Cut",
        "maintain": "Maintain",
        "bulk": "Bulk"
      },
      "form": {
        "name": "Name (optional)",
        "namePlaceholder": "Spring cut, mini-bulk, etc.",
        "phaseType": "Phase type",
        "startDate": "Start date",
        "endDate": "End date (optional)",
        "startWeight": "Start weight",
        "startWeightHint": "Pre-filled from your last weight entry",
        "goalWeight": "Goal weight",
        "goalWeightHintCutBulk": "Required for Cut/Bulk",
        "goalWeightHintMaintain": "Optional for Maintain",
        "notes": "Notes",
        "notesPlaceholder": "Why this phase? Diet, training tweak, deadline…",
        "save": "Save phase",
        "saving": "Saving…",
        "edit": "Edit",
        "cancel": "Cancel",
        "errorMissingStartWeight": "Start weight is required.",
        "errorMissingGoalForCutBulk": "Goal weight is required for Cut and Bulk phases.",
        "errorEndBeforeStart": "End date can't be before start date."
      },
      "stats": {
        "daysInto": "Day {{n}}",
        "delta": "{{delta}} {{unit}}",
        "deltaLost": "Lost {{delta}} {{unit}}",
        "deltaGained": "Gained {{delta}} {{unit}}",
        "deltaNoChange": "No change",
        "progress": "{{percent}}% to phase goal",
        "noPhaseGoal": "No goal set",
        "currentWeight": "Current",
        "phaseGoal": "Goal",
        "phaseStart": "Start"
      },
      "list": {
        "active": "Active",
        "ended": "Ended {{date}}",
        "ongoing": "Ongoing"
      },
      "confirmDelete": "Delete this phase?",
      "confirmDeleteDesc": "The phase is removed but weight entries within it stay intact.",
      "delete": "Delete phase",
      "autoClosedPrev": "Previous phase auto-closed to {{date}}",
      "pacePhase": {
        "ahead": "Ahead of phase pace by {{delta}} {{unit}}/week",
        "on": "On phase pace 🎯",
        "behind": "Behind phase pace by {{delta}} {{unit}}/week"
      }
    },
    "onboarding": {
      "welcome": {
        "title": "Welcome to Phoenix Tracker",
        "subtitle": "Let's set up your goals.",
        "cta": "Get started"
      },
      "name": {
        "title": "What's your name?",
        "subtitle": "We'll use this to greet you.",
        "placeholder": "Your name"
      },
      "birthday": {
        "title": "When's your birthday?",
        "subtitle": "We'll celebrate with you (and compute age)."
      },
      "sex": {
        "title": "Sex",
        "subtitle": "Optional — used for future calculations.",
        "male": "Male",
        "female": "Female",
        "preferNot": "Prefer not to say"
      },
      "units": {
        "title": "Preferred units",
        "subtitle": "You can change this later.",
        "metric": "Metric (kg / cm)",
        "imperial": "Imperial (lb / in)"
      },
      "startWeight": {
        "title": "What's your starting weight?",
        "subtitle": "We'll track progress from this number.",
        "dateLabel": "Started on"
      },
      "goalWeight": {
        "title": "What's your goal weight?",
        "preview": "Total to lose: {{amount}} {{unit}}",
        "warningSameOrHigher": "Goal weight should be less than your starting weight."
      },
      "goalDate": {
        "title": "When do you want to reach it?",
        "subtitle": "Optional — helps us show pace insights.",
        "preview": "{{weeks}} weeks → {{rate}} {{unit}}/week"
      },
      "height": {
        "title": "How tall are you?",
        "subtitle": "Used for BMI calculations."
      },
      "waterGoal": {
        "title": "Daily water goal?",
        "subtitle": "We'll show your progress through the day.",
        "preset2L": "2 L",
        "preset25": "2.5 L",
        "preset3": "3 L"
      },
      "done": {
        "title": "You're all set!",
        "summaryHeader": "Here's your plan:",
        "cta": "Start tracking"
      },
      "nav": {
        "back": "Back",
        "next": "Next",
        "skip": "Skip",
        "edit": "Edit goals",
        "saveChanges": "Save changes"
      },
      "progress": {
        "stepOf": "Step {{current}} of {{total}}"
      }
    },
    "auth": {
      "signIn": "Sign In",
      "signUp": "Sign Up",
      "signOut": "Sign Out",
      "confirmSignOut": "Sign out?",
      "confirmSignOutDesc": "You'll need to log back in to access your data.",
      "email": "Email",
      "password": "Password",
      "noAccount": "Don't have an account?",
      "hasAccount": "Already have an account?",
      "signUpDisabled": "Sign up is currently limited. If you need access, please contact the developer.",
      "signUpOpenWindow": "Sign-up is open for the next {{remaining}}.",
      "signUpCloses": "Closes on {{when}}.",
      "builtBy": "Built by",
      "checkEmail": "Check your email",
      "confirmEmail": "We sent you a confirmation link. Please check your email to verify your account."
    },
    "photos": {
      "title": "Progress Photos",
      "uploadTitle": "Add a Photo",
      "date": "Date",
      "pose": "Pose",
      "front": "Front",
      "side": "Side",
      "back": "Back",
      "selectFile": "Tap to select a photo",
      "caption": "Caption (optional)",
      "captionPlaceholder": "Add a caption...",
      "upload": "Upload",
      "uploading": "Uploading...",
      "delete": "Delete",
      "confirmDelete": "Delete this photo?",
      "confirmDeleteDesc": "The photo file and its database record will be removed.",
      "noPhotos": "No photos yet. Upload your first progress photo!",
      "compressing": "Processing image...",
      "tapToReveal": "Tap to reveal",
      "revealAll": "Reveal all",
      "hideAll": "Hide all",
      "hide": "Hide",
      "storage": {
        "title": "Where should we save this photo?",
        "cloud": "Cloud",
        "cloudDesc": "Synced across devices",
        "cloudLong": "Saved to your account on Supabase. Encrypted at rest. Accessible from any signed-in device. Not end-to-end encrypted.",
        "local": "This device only",
        "localDesc": "Never leaves your phone",
        "localLong": "Saved only in this browser's storage on this device. Will be lost if you uninstall the app, clear site data, or (on iOS) don't open the app for ~7 days. Not synced to other devices.",
        "localBadge": "Stored on this device",
        "pendingBadge": "Waiting to upload — will sync when you're back online"
      },
      "compare": "Compare",
      "comparePhotos": "Compare Photos",
      "selectFirst": "Select first photo (before)",
      "selectSecond": "Select second photo (after)",
      "vs": "vs",
      "all": "All",
      "daysApart": "{{days}} days apart",
      "sameDay": "Same day",
      "needMorePhotos": "Need at least 2 photos to compare"
    },
    "water": {
      "title": "Water Intake",
      "today": "Today",
      "ml": "mL",
      "l": "L",
      "glass": "glass",
      "glasses": "glasses",
      "addGlass": "+1 Glass",
      "addCustom": "Add",
      "customPlaceholder": "Custom amount (mL)",
      "goal": "Daily Goal",
      "goalMet": "Goal met!",
      "noEntries": "No water entries yet. Stay hydrated!",
      "history": "History",
      "edit": "Edit",
      "delete": "Delete",
      "confirmDelete": "Delete this entry?",
      "confirmDeleteDesc": "This will permanently remove this water entry.",
      "addPastDay": "Forgot to log? Add for another day",
      "pastDayAmount": "Amount (mL)",
      "pastDayAdd": "Add",
      "stats": {
        "avg7Day": "7-day avg",
        "avg30Day": "30-day avg",
        "hitRate": "Goal hit rate",
        "bestDay": "Best day",
        "currentStreak": "Streak"
      }
    },
    "export": {
      "exportData": "Export data as CSV"
    },
    "loading": "Loading...",
    "error": "Something went wrong. Please try again.",
    "retry": "Retry",
    "saving": "Saving..."
  },
  "pwa": {
    "install": {
      "title": "Install Routine App",
      "body": "Add it to your home screen for a faster, fullscreen experience.",
      "button": "Install",
      "dismiss": "Not now",
      "iosTitle": "Install on iPhone",
      "iosStep1": "Tap the Share icon",
      "iosStep2": "then select",
      "iosAddToHome": "Add to Home Screen"
    },
    "update": {
      "title": "New version available",
      "subtitle": "Tap update to get the latest fixes",
      "button": "Update",
      "updating": "Updating…",
      "dismiss": "Dismiss"
    }
  },
  "offline": {
    "banner": "You're offline",
    "subtitle": "Showing saved data — changes won't sync until you're back online."
  },
  "sync": {
    "pending": "Syncing…",
    "pendingOffline": "Will sync when online",
    "pendingCount": "{{count}} change(s) pending sync",
    "stuck": "Sync error — tap to retry",
    "retry": "Retry"
  }
};